import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import api from '../../lib/api';
import { fetchCenters } from '../../ducks/centers';
import AdminPageShell from '../../components/admin/AdminPageShell';
import { ADMIN_COMPACT_BUTTON, ADMIN_HEADER_ACTIONS } from '../../styles/adminStyles';
import UnifiedHallSchedule from '../../components/UnifiedHallSchedule';
import {
  aggregateSectionClients,
  formatUserLabel,
  getUserIdFromRequest,
  normalizeListResponse,
} from '../../lib/sectionClientsAggregate';
import {
  buildClientsUserMap,
  buildComplexClientOptions,
  clientLabelFromRow,
  collectPaidUserIds,
} from '../../lib/complexClients';
import { mapOrgClientsToPickerOptions, mergePickerOptions, organizationIdFrom, clientRefFromPickerValue, hasPickerClient, sectionClientWriteFields } from '../../lib/orgClientsPicker';
import {
  formatVisitBalance,
  abonementExpiryBadge,
  ABONEMENT_EXPIRY_COLORS,
} from '../../lib/abonementVisitLabels';
import {
  SECTION_NAV_VIEWS,
  buildSectionsNavPath,
} from '../../lib/sectionNavViews';
import {
  SECTIONS_LIST_HINT,
  SECTIONS_GROUPS_HINT,
  SECTIONS_ABONEMENT_HINT,
} from '../../lib/sectionsGlossaryCopy';
import { getSportNames } from '../../lib/sportUtils';
import { sportsEnum, sportKeysToFlags } from '../../enums';
import ComplexClientPicker from '../../components/sections/ComplexClientPicker';
import { filterTrainerOptions, orgMembersToTrainerOptions } from '../../lib/orgStaff';
import { buildClientProfile, clientRowKey, formatProfileDate } from '../../lib/clientProfile';

const SECTION_SPORT_OPTIONS = Object.keys(sportsEnum)
  .filter((key) => key !== 'rent')
  .map((key) => ({
    key,
    flag: sportKeysToFlags[key],
    label: sportsEnum[key],
  }))
  .filter((opt) => opt.flag != null)
  .sort((a, b) => a.label.localeCompare(b.label, 'ru'));

function formatSectionSportLabel(sportFlag) {
  if (sportFlag == null || sportFlag === '') return '—';
  const names = getSportNames(sportFlag);
  if (names.length) return names.join(', ');
  return String(sportFlag);
}

/** Быстрые периоды в форме абонемента (разовое = один день, без смены модели данных). */
const ABONEMENT_DURATION_PRESETS = [
  { key: 'single', label: 'Разовое посещение', days: 0, isPaid: true },
  { key: 'month', label: 'Месяц', days: 30 },
  { key: 'quarter', label: '3 месяца', days: 90 },
  { key: 'year', label: 'Год', days: 365 },
];

const DETAIL_TABS = [
  { key: 'main', label: 'Обзор' },
  { key: 'schedule', label: 'Расписание' },
  { key: 'requests', label: 'Заявки' },
  { key: 'abonements', label: 'Абонементы' },
  { key: 'personal', label: 'Персональные' },
];

const sectionViews = SECTION_NAV_VIEWS;

const WEEKDAYS = [
  { value: '0', label: 'Вс' },
  { value: '1', label: 'Пн' },
  { value: '2', label: 'Вт' },
  { value: '3', label: 'Ср' },
  { value: '4', label: 'Чт' },
  { value: '5', label: 'Пт' },
  { value: '6', label: 'Сб' },
];

/** Фильтр/статусы заявок: значения должны совпасть с backend при появлении API */
const SECTION_REQUEST_STATUSES = [
  { value: '', label: 'Все статусы' },
  { value: 'New', label: 'Новая' },
  { value: 'InProgress', label: 'В работе' },
  { value: 'Approved', label: 'Одобрена' },
  { value: 'Rejected', label: 'Отклонена' },
];

class SectionsDashboard extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    centers: PropTypes.array,
    playgrounds: PropTypes.array,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    sections: [],
    sectionsLoading: false,
    sectionsError: '',
    saveLoading: false,
    deleteLoadingId: null,
    dialogOpen: false,
    formError: '',
    editingSectionId: null,
    form: {
      name: '',
      sport: '',
      description: '',
    },
    scheduleSectionId: '',
    schedulePlaygroundId: '',
    groups: [],
    groupsLoading: false,
    groupsError: '',
    groupDialogOpen: false,
    groupFormError: '',
    editingGroupId: null,
    groupSaveLoading: false,
    groupDeleteId: null,
    groupForm: {
      name: '',
      maxParticipants: '',
      isClosedGroup: false,
      trainerId: '',
      playgroundId: '',
      schedules: [{ dayOfWeek: '1', startTime: '10:00', endTime: '11:00' }],
    },
    requests: [],
    requestsLoading: false,
    requestsError: '',
    requestFilterSectionId: '',
    requestFilterStatus: '',
    requestActionLoadingId: null,
    approveDialogOpen: false,
    approveTarget: null,
    approveGroupId: '',
    approveError: '',
    approveSaveLoading: false,
    approveGroups: [],
    approveGroupsLoading: false,
    abonements: [],
    abonementsLoading: false,
    abonementsError: '',
    abonementFilterSectionId: '',
    abonementFilterUserId: '',
    abonementDialogOpen: false,
    abonementDialogHint: '',
    abonementFormError: '',
    editingAbonementId: null,
    abonementSaveLoading: false,
    abonementDeleteId: null,
    abonementForm: {
      userId: '',
      dateFrom: '',
      dateTo: '',
      isPaid: false,
      sectionIds: [],
      tariffId: '',
      amount: '',
      note: '',
      visitLimit: '',
      visitsRemaining: '',
    },
    tariffs: [],
    tariffsLoading: false,
    tariffsError: '',
    tariffDialogOpen: false,
    tariffFormError: '',
    editingTariffId: null,
    tariffSaveLoading: false,
    tariffDeleteId: null,
    tariffForm: {
      name: '',
      price: '',
      durationDays: '30',
      visitLimit: '',
      isActive: true,
      sectionIds: [],
    },
    paidSum: null,
    paidSumLoading: false,
    paidSumError: '',
    personalTrainings: [],
    personalLoading: false,
    personalError: '',
    personalFilterSectionId: '',
    personalFilterUserId: '',
    personalDialogOpen: false,
    personalFormError: '',
    editingPersonalId: null,
    personalSaveLoading: false,
    personalDeleteId: null,
    personalForm: {
      sectionId: '',
      userId: '',
      startDateTime: '',
      endDateTime: '',
      durationMinutes: '60',
      trainerId: '',
      playgroundId: '',
    },
    clientsRows: [],
    clientsLoading: false,
    clientsError: '',
    clientsSearch: '',
    clientsUserMap: {},
    unmergeClientId: null,
    complexClientOptions: [],
    complexClientsLoading: false,
    organization: null,
    orgClients: [],
    newClientName: '',
    newClientPhone: '',
    newClientSaving: false,
    newClientError: '',
    clientCardRow: null,
    detailSectionId: null,
    detailTab: 'main',
    membersDialogOpen: false,
    membersGroup: null,
    membersRows: [],
    membersLoading: false,
    membersError: '',
    membersAddUserId: '',
    membersAddSearch: '',
    membersSaveLoading: false,
    membersDeleteId: null,
    userSearchResults: [],
    userSearchLoading: false,
    abonementReminderOpen: false,
    abonementReminderUserId: null,
    abonementReminderClientName: '',
    abonementReminderSectionId: null,
    markInProgressLoadingId: null,
    trainers: [],
    trainersLoading: false,
    trainersError: '',
    trainerSearch: '',
  };

  componentDidMount() {
    if ((!this.props.centers || !this.props.centers.length) && this.props.fetchCenters) {
      this.props.fetchCenters().catch(() => {});
    }
    const centerId = this.getCenterIdFromProps(this.props);
    if (!centerId) {
      if (Array.isArray(this.props.centers) && this.props.centers.length) {
        const viewParam = this.props.match.params.view;
        const viewPart = viewParam ? `/${viewParam}` : '';
        this.props.history.replace(
          `/sections${viewPart}?centerId=${encodeURIComponent(String(this.props.centers[0].id != null ? this.props.centers[0].id : this.props.centers[0].Id))}`,
        );
      }
      return;
    }

    this.loadSections();
    this.loadTrainers();
    this.loadClients();
    const view = this.getActiveView();
    if (view === 'requests') this.loadRequests();
    if (view === 'abonements') { this.loadAbonements(); this.loadTariffs(); this.loadPaidSum(); }
    if (view === 'personal') this.loadPersonalTrainings();
  }

  componentDidUpdate(prevProps) {
    const prevCentersLen = (prevProps.centers || []).length;
    const centersLen = (this.props.centers || []).length;
    if (prevCentersLen === 0 && centersLen > 0 && !this.getCenterIdFromProps(this.props)) {
      const first = this.props.centers[0];
      const firstId = first && (first.id != null ? first.id : first.Id);
      if (firstId && this.props.history) {
        const viewParam = this.props.match.params.view;
        const viewPart = viewParam ? `/${viewParam}` : '';
        this.props.history.replace(
          `/sections${viewPart}?centerId=${encodeURIComponent(String(firstId))}`,
        );
      }
      return;
    }
    const prevCenterId = this.getCenterIdFromProps(prevProps);
    const centerId = this.getCenterIdFromProps(this.props);
    if (prevCenterId !== centerId) {
      this.setState({
        scheduleSectionId: '',
        groups: [],
        groupsError: '',
        requestFilterSectionId: '',
        requestFilterStatus: '',
        requests: [],
        requestsError: '',
        abonementFilterSectionId: '',
        abonementFilterUserId: '',
        abonements: [],
        abonementsError: '',
        personalFilterSectionId: '',
        personalFilterUserId: '',
        personalTrainings: [],
        personalError: '',
        clientsRows: [],
        clientsError: '',
      }, async () => {
        await this.loadSections();
        this.loadTrainers();
        this.loadClients();
        const view = this.getActiveView();
        if (view === 'requests') this.loadRequests();
        if (view === 'abonements') { this.loadAbonements(); this.loadTariffs(); this.loadPaidSum(); }
        if (view === 'personal') this.loadPersonalTrainings();
      });
      return;
    }

    const view = this.getActiveView();
    const prevViewRaw = prevProps.match.params.view;
    const prevView = sectionViews.find((v) => v.key === prevViewRaw) ? prevViewRaw : 'list';

    if (view !== prevView && this.state.detailSectionId) {
      this.setState({ detailSectionId: null, detailTab: 'main' });
    }

    if (view === 'schedule' && prevView !== 'schedule' && this.state.sections.length && !this.state.scheduleSectionId) {
      const id = this.state.sections[0].id;
      this.setState({ scheduleSectionId: id });
      this.loadGroups(id);
    }

    if (view === 'requests' && prevView !== 'requests') {
      this.loadRequests();
    }

    if (view === 'abonements' && prevView !== 'abonements') {
      this.loadAbonements();
      this.loadClients();
    }

    if (view === 'personal' && prevView !== 'personal') {
      this.loadPersonalTrainings();
      this.loadClients();
    }

    if (view === 'schedule' && prevView !== 'schedule') {
      this.loadClients();
    }

    if (view === 'clients' && prevView !== 'clients') {
      this.loadClients();
    }

    const prevQuery = new URLSearchParams(prevProps.location.search || '');
    const query = new URLSearchParams(this.props.location.search || '');
    const prevSid = prevQuery.get('sectionId');
    const sid = query.get('sectionId');
    if (sid !== prevSid && sid && this.state.sections.length) {
      this.applyDeepLinkSectionId(this.state.sections, sid);
    }
  }

  getSectionIdFromQuery = (props = this.props) => {
    const search = props && props.location ? props.location.search : '';
    const query = new URLSearchParams(search || '');
    return query.get('sectionId');
  };

  applyDeepLinkSectionId = (sectionsList, sectionIdParam) => {
    const raw = sectionIdParam != null ? sectionIdParam : this.getSectionIdFromQuery();
    if (!raw) return;
    const n = Number(raw);
    if (Number.isNaN(n)) return;
    const list = sectionsList || this.state.sections || [];
    const found = list.find((s) => Number(s.id) === n);
    if (!found) return;

    this.setState(
      {
        scheduleSectionId: n,
        requestFilterSectionId: String(n),
        abonementFilterSectionId: String(n),
        personalFilterSectionId: String(n),
      },
      () => {
        this.loadGroups(n);
        const view = this.getActiveView();
        if (view === 'requests') this.loadRequests();
        if (view === 'abonements') { this.loadAbonements(); this.loadTariffs(); this.loadPaidSum(); }
        if (view === 'personal') this.loadPersonalTrainings();
      },
    );
  };

  loadTrainers = async () => {
    const centerId = Number(this.getCenterId());
    if (!centerId) {
      this.setState({ trainers: [], trainersLoading: false, trainersError: '' });
      return;
    }
    this.setState({ trainersLoading: true, trainersError: '' });
    try {
      const org = await api.getOrganizationByComplex(centerId);
      const orgId = org && (org.id != null ? org.id : org.Id);
      if (!orgId) {
        this.setState({
          trainers: [],
          trainersLoading: false,
          trainersError: 'У клуба нет организации — сотрудников выбрать нельзя',
        });
        return;
      }
      const members = normalizeListResponse(await api.getOrganizationMembers(orgId));
      this.setState({
        trainers: orgMembersToTrainerOptions(members, centerId),
        trainersLoading: false,
      });
    } catch (error) {
      this.setState({
        trainers: [],
        trainersLoading: false,
        trainersError: error.message || 'Не удалось загрузить сотрудников организации',
      });
    }
  };

  handleTrainerSearchChange = (event) => {
    this.setState({ trainerSearch: event.target.value });
  };

  /**
   * Выбор тренера из сотрудников организации клуба (без глобального getUsers).
   * onChange(value: string) — '' или numeric userId.
   */
  renderTrainerSelect = (value, onChange, label = 'Тренер (опционально)', selectId = 'section-trainer') => {
    const { classes, history } = this.props;
    const { trainers, trainersLoading, trainersError, trainerSearch } = this.state;
    const setValue = (next) => {
      if (typeof onChange === 'function') onChange(String(next == null ? '' : next));
    };
    const current = value === '' || value == null ? '' : String(value);
    const filtered = filterTrainerOptions(trainers, trainerSearch);
    const hasCurrent =
      current !== ''
      && (trainers || []).some((u) => String(u.id != null ? u.id : u.Id) === current);
    const currentLabel = this.trainerLabelById(current);
    const centerId = this.getCenterId();

    return (
      <div className={classes.trainerPicker}>
        <TextField
          margin="dense"
          label="Поиск сотрудника"
          value={trainerSearch}
          onChange={this.handleTrainerSearchChange}
          fullWidth
          disabled={trainersLoading}
          helperText="Тренер выбирается из сотрудников организации этого клуба."
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id={`${selectId}-label`} shrink>
            {label}
          </InputLabel>
          <Select
            labelId={`${selectId}-label`}
            value={current}
            onChange={(e) => setValue(e.target.value)}
            disabled={trainersLoading}
            displayEmpty
          >
            <MenuItem value="">
              <em>Не задан</em>
            </MenuItem>
            {!hasCurrent && current !== '' && (
              <MenuItem value={current}>{`${currentLabel} (не в списке сотрудников)`}</MenuItem>
            )}
            {filtered.map((u) => {
              const id = u.id != null ? u.id : u.Id;
              return (
                <MenuItem key={id} value={String(id)}>
                  {u.label || formatUserLabel(u)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {!trainersLoading && !trainersError && (trainers || []).length === 0 && (
          <Typography variant="caption" color="textSecondary" display="block">
            У клуба пока нет сотрудников. Добавьте их в разделе «Сотрудники».
          </Typography>
        )}
        {trainersError && (
          <Typography variant="caption" color="error" className={classes.errorText} display="block">
            {trainersError}
          </Typography>
        )}
        {history && (
          <Button
            size="small"
            color="primary"
            onClick={() =>
              history.push(
                centerId
                  ? `/organization/staff?complexId=${encodeURIComponent(String(centerId))}`
                  : '/organization/staff',
              )
            }
            style={{ marginTop: 4 }}
          >
            Открыть сотрудников
          </Button>
        )}
      </div>
    );
  };

  trainerLabelById = (trainerId) => {
    if (trainerId == null || trainerId === '') return '—';
    const u = this.state.trainers.find((x) => Number(x.id != null ? x.id : x.Id) === Number(trainerId));
    if (!u) return '—';
    return u.label || formatUserLabel(u) || '—';
  };

  playgroundLabelById = (playgroundId) => {
    if (playgroundId == null || playgroundId === '') return '—';
    const n = Number(playgroundId);
    const p = (this.props.playgrounds || []).find(
      (x) => Number(x.id != null ? x.id : x.Id) === n,
    );
    const name = p && (p.name || p.Name);
    return name || '—';
  };

  playgroundLabelFromRow = (row) => {
    if (!row) return '—';
    const named = row.playgroundName || row.PlaygroundName;
    if (named) return named;
    const pid = row.playgroundId != null ? row.playgroundId : row.PlaygroundId;
    return this.playgroundLabelById(pid);
  };

  getActiveView() {
    const currentView = this.props.match.params.view;
    return sectionViews.find((view) => view.key === currentView) ? currentView : 'list';
  }

  getCenterIdFromProps = (props) => {
    const routeCenterId = props && props.match && props.match.params ? props.match.params.centerId : null;
    const search = props && props.location ? props.location.search : '';
    const query = new URLSearchParams(search || '');
    const queryCenterId = query.get('centerId');
    return routeCenterId || queryCenterId || '';
  };

  getCenterId = () => this.getCenterIdFromProps(this.props);

  goToView = (viewKey) => {
    const centerId = this.getCenterId();
    if (!centerId) return;
    const sectionId =
      this.getSectionIdFromQuery()
      || (this.state.scheduleSectionId ? String(this.state.scheduleSectionId) : '');
    const params = new URLSearchParams();
    params.set('centerId', String(centerId));
    if (sectionId) params.set('sectionId', String(sectionId));
    this.props.history.push(buildSectionsNavPath(viewKey, `?${params.toString()}`));
  };

  handleCenterSelectChange = (event) => {
    const nextCenterId = event.target.value;
    if (!nextCenterId) return;
    const viewParam = this.props.match.params.view;
    const viewPart = viewParam ? `/${viewParam}` : '';
    this.props.history.push(`/sections${viewPart}?centerId=${encodeURIComponent(String(nextCenterId))}`);
  };

  loadSections = async () => {
    const centerId = this.getCenterId();
    if (!centerId) return;
    this.setState({ sectionsLoading: true, sectionsError: '' });
    try {
      const sections = await api.getSections({ complexId: centerId });
      const list = Array.isArray(sections) ? sections : [];
      this.setState({ sections: list, sectionsLoading: false }, () => {
        const view = this.getActiveView();
        const sectionIdFromQuery = this.getSectionIdFromQuery();
        if (sectionIdFromQuery) {
          this.applyDeepLinkSectionId(list, sectionIdFromQuery);
          return;
        }
        if (view === 'schedule' && list.length && !this.state.scheduleSectionId) {
          const firstId = list[0].id;
          this.setState({ scheduleSectionId: firstId });
          this.loadGroups(firstId);
        }
      });
    } catch (error) {
      this.setState({
        sectionsLoading: false,
        sectionsError: error.message || 'Не удалось загрузить список секций',
      });
    }
  };

  loadGroups = async (sectionId) => {
    if (!sectionId) return;
    this.setState({ groupsLoading: true, groupsError: '' });
    try {
      const groups = await api.getSectionGroups(sectionId);
      this.setState({ groups: Array.isArray(groups) ? groups : [], groupsLoading: false });
    } catch (error) {
      this.setState({
        groupsLoading: false,
        groupsError: error.message || 'Не удалось загрузить группы',
      });
    }
  };

  handleScheduleSectionChange = (event) => {
    const id = Number(event.target.value);
    this.setState({ scheduleSectionId: id, groups: [] });
    this.loadGroups(id);
  };

  normalizeSchedulesFromGroup(group) {
    const raw = group.sectionSchedules || group.schedules || group.sectionSchedule || [];
    if (!Array.isArray(raw) || raw.length === 0) {
      return [{ dayOfWeek: '1', startTime: '10:00', endTime: '11:00' }];
    }
    return raw.map((s) => ({
      dayOfWeek: String(s.dayOfWeek != null ? s.dayOfWeek : s.day ?? ''),
      startTime: s.startTime || s.start || '',
      endTime: s.endTime || s.end || '',
    }));
  }

  formatGroupScheduleHint(group) {
    const raw = group.sectionSchedules || group.schedules || group.sectionSchedule || [];
    if (!Array.isArray(raw) || raw.length === 0) return 'Расписание не задано';
    return raw
      .map((s) => {
        const dayVal = String(s.dayOfWeek != null ? s.dayOfWeek : s.day ?? '');
        const day = WEEKDAYS.find((d) => d.value === dayVal);
        const start = s.startTime || s.start || '—';
        const end = s.endTime || s.end || '—';
        return `${day ? day.label : dayVal} ${start}–${end}`;
      })
      .join(', ');
  }

  isSectionDetailScoped = () => !!this.state.detailSectionId;

  openCreateGroupDialog = () => {
    this.setState({
      groupDialogOpen: true,
      editingGroupId: null,
      groupFormError: '',
      groupForm: {
        name: '',
        maxParticipants: '',
        isClosedGroup: false,
        trainerId: '',
        playgroundId: '',
        schedules: [{ dayOfWeek: '1', startTime: '10:00', endTime: '11:00' }],
      },
    });
  };

  openEditGroupDialog = (group) => {
    this.setState({
      groupDialogOpen: true,
      editingGroupId: group.id,
      groupFormError: '',
      groupForm: {
        name: group.name || '',
        maxParticipants: group.maxParticipants != null ? String(group.maxParticipants) : '',
        isClosedGroup: !!group.isClosedGroup,
        trainerId: group.trainerId != null ? String(group.trainerId) : '',
        playgroundId: group.playgroundId != null ? String(group.playgroundId) : '',
        schedules: this.normalizeSchedulesFromGroup(group),
      },
    });
  };

  closeGroupDialog = () => {
    this.setState({
      groupDialogOpen: false,
      groupSaveLoading: false,
      groupFormError: '',
    });
  };

  handleGroupFieldChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState((prev) => ({
      groupForm: {
        ...prev.groupForm,
        [name]: type === 'checkbox' ? checked : value,
      },
    }));
  };

  handleScheduleRowChange = (index, field, value) => {
    this.setState((prev) => {
      const schedules = [...prev.groupForm.schedules];
      schedules[index] = { ...schedules[index], [field]: value };
      return { groupForm: { ...prev.groupForm, schedules } };
    });
  };

  addScheduleRow = () => {
    this.setState((prev) => ({
      groupForm: {
        ...prev.groupForm,
        schedules: [...prev.groupForm.schedules, { dayOfWeek: '1', startTime: '10:00', endTime: '11:00' }],
      },
    }));
  };

  removeScheduleRow = (index) => {
    this.setState((prev) => {
      const schedules = prev.groupForm.schedules.filter((_, i) => i !== index);
      return {
        groupForm: {
          ...prev.groupForm,
          schedules: schedules.length ? schedules : [{ dayOfWeek: '1', startTime: '10:00', endTime: '11:00' }],
        },
      };
    });
  };

  submitGroup = async () => {
    const { scheduleSectionId, editingGroupId, groupForm } = this.state;
    const name = (groupForm.name || '').trim();
    if (!scheduleSectionId) {
      this.setState({ groupFormError: 'Выберите секцию' });
      return;
    }
    if (!name) {
      this.setState({ groupFormError: 'Название группы обязательно' });
      return;
    }

    const sectionSchedules = groupForm.schedules.map((s) => ({
      dayOfWeek: Number(s.dayOfWeek),
      startTime: (s.startTime || '').trim(),
      endTime: (s.endTime || '').trim(),
    }));

    const invalidSlot = sectionSchedules.some(
      (s) => Number.isNaN(s.dayOfWeek) || !s.startTime || !s.endTime,
    );
    if (invalidSlot) {
      this.setState({ groupFormError: 'Укажите день недели и время для каждого слота' });
      return;
    }

    const payload = {
      name,
      maxParticipants: groupForm.maxParticipants === '' ? null : Number(groupForm.maxParticipants),
      isClosedGroup: !!groupForm.isClosedGroup,
      trainerId: groupForm.trainerId === '' ? null : Number(groupForm.trainerId),
      playgroundId: groupForm.playgroundId === '' ? null : Number(groupForm.playgroundId),
      sectionSchedules,
    };

    this.setState({ groupSaveLoading: true, groupFormError: '' });
    try {
      if (editingGroupId) {
        await api.updateSectionGroup(scheduleSectionId, editingGroupId, { ...payload, id: editingGroupId });
      } else {
        await api.createSectionGroup(scheduleSectionId, payload);
      }
      this.closeGroupDialog();
      await this.loadGroups(scheduleSectionId);
      await this.loadSections();
    } catch (error) {
      this.setState({
        groupSaveLoading: false,
        groupFormError: error.message || 'Не удалось сохранить группу',
      });
    }
  };

  deleteGroup = async (groupId) => {
    const { scheduleSectionId } = this.state;
    if (!scheduleSectionId) return;
    this.setState({ groupDeleteId: groupId, groupsError: '' });
    try {
      await api.deleteSectionGroup(scheduleSectionId, groupId);
      await this.loadGroups(scheduleSectionId);
      await this.loadSections();
      this.setState({ groupDeleteId: null });
    } catch (error) {
      this.setState({
        groupDeleteId: null,
        groupsError: error.message || 'Не удалось удалить группу',
      });
    }
  };

  getRequestSectionId = (req) =>
    req.sectionId != null ? req.sectionId : req.sectionID != null ? req.sectionID : req.section?.id;

  getRequestType = (req) => {
    if (!req) return '';
    return (req.type || req.requestType || req.kind || '').toString();
  };

  isGroupRequest = (req) => {
    if (!req) return false;
    const t = this.getRequestType(req).toLowerCase();
    return t === 'group' || t === 'grouptraining' || t === '1';
  };

  isOneTimeRequest = (req) => {
    if (!req) return false;
    const t = this.getRequestType(req).toLowerCase();
    return t === '3' || t === 'onetime' || t === 'single';
  };

  approveRequestKindLabel = (req) => {
    if (this.isGroupRequest(req)) return ' · в группу';
    if (this.isOneTimeRequest(req)) return ' · разовое';
    return ' · персональная';
  };

  requestStatusLabel = (status) => {
    const CODE_TO_NAME = { 0: 'New', 1: 'InProgress', 2: 'Approved', 3: 'Rejected' };
    let key = status == null || status === '' ? '' : String(status);
    if (CODE_TO_NAME[key] != null) key = CODE_TO_NAME[key];
    else if (CODE_TO_NAME[Number(status)] != null && status !== '' && !Number.isNaN(Number(status))) {
      key = CODE_TO_NAME[Number(status)];
    }
    const s = SECTION_REQUEST_STATUSES.find((x) => x.value === key);
    return s ? s.label : (status != null && status !== '' ? String(status) : '—');
  };

  requestTypeLabel = (req) => {
    const raw = this.getRequestType(req);
    if (raw === '3' || String(raw).toLowerCase() === 'onetime' || String(raw).toLowerCase() === 'single') {
      return 'Разовое';
    }
    if (this.isGroupRequest(req)) return 'Группа';
    if (!raw) return '—';
    if (['personal', 'personaltraining', '2'].includes(String(raw).toLowerCase())) return 'Персонал';
    return raw;
  };

  loadRequests = async () => {
    const centerId = this.getCenterId();
    const { requestFilterSectionId, requestFilterStatus } = this.state;
    this.setState({ requestsLoading: true, requestsError: '' });
    try {
      const params = { complexId: centerId };
      if (requestFilterSectionId) params.sectionId = requestFilterSectionId;
      if (requestFilterStatus) params.status = requestFilterStatus;
      const data = await api.getSectionRequests(params);
      let list = [];
      if (Array.isArray(data)) list = data;
      else if (data && Array.isArray(data.items)) list = data.items;
      else if (data && Array.isArray(data.results)) list = data.results;
      this.setState({ requests: list.filter(Boolean), requestsLoading: false });
    } catch (error) {
      this.setState({
        requestsLoading: false,
        requestsError: error.message || 'Не удалось загрузить заявки',
      });
    }
  };

  handleRequestFilterSectionChange = (event) => {
    this.setState({ requestFilterSectionId: event.target.value }, () => this.loadRequests());
  };

  handleRequestFilterStatusChange = (event) => {
    this.setState({ requestFilterStatus: event.target.value }, () => this.loadRequests());
  };

  requestPersonLabel = (req) => {
    if (!req) return 'Без имени';
    const name = req.userName || req.UserName;
    if (name) return name;
    const phone = this.requestPhone(req);
    const email = this.requestEmail(req);
    return phone || email || 'Без имени';
  };

  requestPhone = (req) => {
    if (!req) return '';
    const phone = (req.userPhone || req.UserPhone || '').toString().trim();
    if (phone) return phone;
    const login = (req.userLogin || req.UserLogin || req.login || req.Login || '').toString().trim();
    return login;
  };

  requestEmail = (req) => {
    if (!req) return '';
    return (req.userEmail || req.UserEmail || '').toString().trim();
  };

  requestComment = (req) => {
    if (!req) return '';
    return (req.comment || req.Comment || '').toString().trim();
  };

  requestGroupLabel = (req) => {
    if (!req) return '—';
    const named = req.sectionGroupName || req.SectionGroupName;
    if (named) return named;
    const gid = req.sectionGroupId != null ? req.sectionGroupId : req.SectionGroupId;
    if (gid == null) return '—';
    const g = (this.state.groups || []).find((x) => Number(x.id) === Number(gid))
      || (this.state.approveGroups || []).find((x) => Number(x.id) === Number(gid));
    return g && g.name ? g.name : '—';
  };

  sectionTitleById = (sectionId) => {
    const n = Number(sectionId);
    const s = this.state.sections.find((x) => Number(x.id) === n);
    return s && s.name ? s.name : '—';
  };

  normalizeAbonementSectionIds = (row) => {
    if (Array.isArray(row.sectionIds)) return row.sectionIds.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
    if (Array.isArray(row.sections))
      return row.sections
        .map((s) => Number(s && (s.id != null ? s.id : s.sectionId)))
        .filter((id) => !Number.isNaN(id));
    if (Array.isArray(row.abonementSections))
      return row.abonementSections
        .map((x) => Number(x && (x.sectionId != null ? x.sectionId : x.section && x.section.id)))
        .filter((id) => !Number.isNaN(id));
    return [];
  };

  normalizeAbonementDates = (row) => {
    const from = row.dateFrom || row.startDate || row.DateFrom;
    const to = row.dateTo || row.endDate || row.DateTo;
    return {
      dateFrom: this.toAbonementDateInput(from),
      dateTo: this.toAbonementDateInput(to),
    };
  };

  normalizeAbonementPaid = (row) => {
    if (row.isPaid != null) return !!row.isPaid;
    if (row.paid != null) return !!row.paid;
    const ps = (row.paymentStatus || '').toString().toLowerCase();
    return ps === 'paid' || ps === 'оплачен';
  };

  abonementSectionsDisplay = (row) => {
    const ids = this.normalizeAbonementSectionIds(row);
    if (!ids.length) return '—';
    return ids.map((id) => this.sectionTitleById(id)).join(', ');
  };


  addDaysDateInput = (yyyyMmDd, days) => {
    const d = new Date(`${yyyyMmDd}T00:00:00`);
    d.setDate(d.getDate() + Number(days));
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  loadPaidSum = async () => {
    const centerId = this.getCenterId();
    if (!centerId) return;
    this.setState({ paidSumLoading: true, paidSumError: '' });
    try {
      const params = { complexId: centerId };
      if (this.state.abonementFilterSectionId) params.sectionId = this.state.abonementFilterSectionId;
      const data = await api.getAbonementsPaidSum(params);
      this.setState({ paidSum: data || null, paidSumLoading: false });
    } catch (error) {
      this.setState({
        paidSumLoading: false,
        paidSumError: error.message || 'Не удалось загрузить сумму оплаченных',
        paidSum: null,
      });
    }
  };

  loadTariffs = async () => {
    const centerId = this.getCenterId();
    if (!centerId) return [];
    this.setState({ tariffsLoading: true, tariffsError: '' });
    try {
      const data = await api.getAbonementTariffs({ complexId: centerId });
      let list = [];
      if (Array.isArray(data)) list = data;
      else if (data && Array.isArray(data.items)) list = data.items;
      list = list.filter(Boolean);
      this.setState({ tariffs: list, tariffsLoading: false });
      return list;
    } catch (error) {
      this.setState({
        tariffsLoading: false,
        tariffsError: error.message || 'Не удалось загрузить тарифы',
      });
      return [];
    }
  };

  openTariffDialog = (row = null) => {
    if (row) {
      const sectionIds = Array.isArray(row.sectionIds) ? row.sectionIds.map(Number) : [];
      this.setState({
        tariffDialogOpen: true,
        editingTariffId: row.id,
        tariffFormError: '',
        tariffForm: {
          name: row.name || '',
          price: row.price != null ? String(row.price) : '',
          durationDays: row.durationDays != null ? String(row.durationDays) : '',
          visitLimit: row.visitLimit != null ? String(row.visitLimit) : '',
          isActive: row.isActive !== false,
          sectionIds,
        },
      });
    } else {
      const detailSid = this.state.detailSectionId;
      const filterSid = this.state.abonementFilterSectionId;
      let defaultSectionIds = [];
      if (detailSid) {
        defaultSectionIds = [Number(detailSid)];
      } else if (filterSid) {
        defaultSectionIds = [Number(filterSid)];
      } else if (Array.isArray(this.state.sections) && this.state.sections.length === 1) {
        defaultSectionIds = [Number(this.state.sections[0].id)];
      }
      this.setState({
        tariffDialogOpen: true,
        editingTariffId: null,
        tariffFormError: '',
        tariffForm: {
          name: '',
          price: '',
          durationDays: '30',
          visitLimit: '',
          isActive: true,
          sectionIds: defaultSectionIds.filter((id) => !Number.isNaN(id)),
        },
      });
    }
  };

  closeTariffDialog = () => {
    this.setState({
      tariffDialogOpen: false,
      tariffFormError: '',
      editingTariffId: null,
      tariffSaveLoading: false,
    });
  };

  submitTariff = async () => {
    const centerId = this.getCenterId();
    const { editingTariffId, tariffForm } = this.state;
    const name = (tariffForm.name || '').trim();
    const price = Number(tariffForm.price);
    if (!name) {
      this.setState({ tariffFormError: 'Укажите название тарифа' });
      return;
    }
    if (Number.isNaN(price) || price < 0) {
      this.setState({ tariffFormError: 'Укажите корректную цену' });
      return;
    }
    const payload = {
      sportComplexId: Number(centerId),
      name,
      price,
      durationDays: tariffForm.durationDays === '' || tariffForm.durationDays == null
        ? null
        : Number(tariffForm.durationDays),
      visitLimit: tariffForm.visitLimit === '' || tariffForm.visitLimit == null
        ? null
        : Number(tariffForm.visitLimit),
      isActive: !!tariffForm.isActive,
      sectionIds: (tariffForm.sectionIds || []).map(Number).filter((id) => !Number.isNaN(id)),
    };
    if (payload.durationDays != null && Number.isNaN(payload.durationDays)) {
      this.setState({ tariffFormError: 'Длительность — число дней или пусто' });
      return;
    }
    this.setState({ tariffSaveLoading: true, tariffFormError: '' });
    try {
      if (editingTariffId) {
        await api.updateAbonementTariff(editingTariffId, { ...payload, id: editingTariffId });
      } else {
        await api.createAbonementTariff(payload);
      }
      this.closeTariffDialog();
      await this.loadTariffs();
    } catch (error) {
      this.setState({
        tariffSaveLoading: false,
        tariffFormError: error.message || 'Не удалось сохранить тариф',
      });
    }
  };

  deleteTariff = async (id) => {
    if (!window.confirm('Удалить тариф из прайса?')) return;
    this.setState({ tariffDeleteId: id });
    try {
      await api.deleteAbonementTariff(id);
      await this.loadTariffs();
      this.setState({ tariffDeleteId: null });
    } catch (error) {
      this.setState({
        tariffDeleteId: null,
        tariffsError: error.message || 'Не удалось удалить тариф',
      });
    }
  };

  applyTariffToAbonementForm = (tariffId) => {
    const tid = tariffId === '' || tariffId == null ? '' : String(tariffId);
    const tariff = (this.state.tariffs || []).find((x) => String(x.id) === tid);
    this.setState((prev) => {
      const form = { ...prev.abonementForm, tariffId: tid };
      if (tariff) {
        if (tariff.price != null) form.amount = String(tariff.price);
        if (tariff.durationDays != null && tariff.durationDays > 0 && form.dateFrom) {
          form.dateTo = this.addDaysDateInput(form.dateFrom, Number(tariff.durationDays));
        }
        if (Array.isArray(tariff.sectionIds) && tariff.sectionIds.length) {
          form.sectionIds = tariff.sectionIds.map(Number);
        }
        if (tariff.visitLimit != null && tariff.visitLimit !== '') {
          form.visitLimit = String(tariff.visitLimit);
          form.visitsRemaining = String(tariff.visitLimit);
        } else {
          form.visitLimit = '';
          form.visitsRemaining = '';
        }
      } else {
        form.visitLimit = '';
        form.visitsRemaining = '';
      }
      return { abonementForm: form, abonementFormError: '' };
    });
  };

  loadAbonements = async () => {
    const centerId = this.getCenterId();
    const { abonementFilterSectionId } = this.state;
    this.setState({ abonementsLoading: true, abonementsError: '' });
    try {
      const params = { complexId: centerId };
      if (abonementFilterSectionId) params.sectionId = abonementFilterSectionId;
      const data = await api.getAbonements(params);
      let list = [];
      if (Array.isArray(data)) list = data;
      else if (data && Array.isArray(data.items)) list = data.items;
      else if (data && Array.isArray(data.results)) list = data.results;
      this.setState({ abonements: list, abonementsLoading: false });
    } catch (error) {
      this.setState({
        abonementsLoading: false,
        abonementsError: error.message || 'Не удалось загрузить абонементы',
      });
    }
  };

  handleAbonementFilterSectionChange = (event) => {
    this.setState({ abonementFilterSectionId: event.target.value }, () => { this.loadAbonements(); this.loadPaidSum(); });
  };

  handleAbonementFilterUserBlur = () => {
    this.loadAbonements();
  };

  openCreateAbonementDialog = () => {
    this.openAbonementDialog({
      hint: 'Для разового визита используйте пресет «Разовое посещение» (один день, оплачен).',
    });
  };

  openEditAbonementDialog = (row) => {
    if (!row) return;
    const { dateFrom, dateTo } = this.normalizeAbonementDates(row);
    const tariffId = row.tariffId != null ? row.tariffId : row.TariffId;
    const amount = row.amount != null ? row.amount : row.Amount;
    const note = row.note != null ? row.note : (row.Note || '');
    const visitLimit = row.visitLimit != null ? row.visitLimit : row.VisitLimit;
    const visitsRemaining = row.visitsRemaining != null ? row.visitsRemaining : row.VisitsRemaining;
    this.openAbonementDialog({
      userId: row.userId != null ? String(row.userId) : (row.UserId != null ? String(row.UserId) : ''),
      sectionIds: this.normalizeAbonementSectionIds(row),
        dateFrom,
        dateTo,
        isPaid: this.normalizeAbonementPaid(row),
      editingId: row.id != null ? row.id : row.Id,
      tariffId: tariffId != null ? tariffId : '',
      amount: amount != null ? amount : '',
      note: note || '',
      visitLimit: visitLimit != null ? visitLimit : '',
      visitsRemaining: visitsRemaining != null ? visitsRemaining : '',
    });
  };

  listAbonementsForLookup = () => {
    const cache = this.state._clientsCache || {};
    if (cache.abonements && cache.abonements.length) return cache.abonements;
    return this.state.abonements || [];
  };

  findAbonementById = (id) => {
    if (id == null || id === '') return null;
    const n = Number(id);
    return this.listAbonementsForLookup().find((a) => Number(a.id != null ? a.id : a.Id) === n) || null;
  };

  findPersonalById = (id) => {
    if (id == null || id === '') return null;
    const n = Number(id);
    const cache = this.state._clientsCache || {};
    const list = (cache.personalTrainings && cache.personalTrainings.length)
      ? cache.personalTrainings
      : (this.state.personalTrainings || []);
    return list.find((p) => Number(p.id != null ? p.id : p.Id) === n) || null;
  };

  handleIssueAbonementFromClientCard = () => {
    const { clientCardRow } = this.state;
    if (!clientCardRow) return;

    const userId = clientCardRow.userId != null && clientCardRow.userId !== ''
      ? Number(clientCardRow.userId)
      : null;

    if (userId != null) {
      const pending = this.findPendingRequestsForUser(userId);
      if (pending.length) {
        window.alert(
          'Сначала одобрите заявку клиента (кнопка «Одобрить» в списке заявок). '
          + 'Абонемент даёт право записи, но не заменяет одобрение заявки.',
        );
        return;
      }
    }

    const pickerUserId = clientCardRow.userId != null && clientCardRow.userId !== ''
      ? String(clientCardRow.userId)
      : (clientCardRow.businessClientId ? `bc-${clientCardRow.businessClientId}` : '');

    let sectionIds = [];
    if (userId != null) {
      sectionIds = this.collectSectionIdsFromRequests(this.findApprovedRequestsForUser(userId));
    }
    if (!sectionIds.length && this.state.detailSectionId) {
      sectionIds = [Number(this.state.detailSectionId)];
    }

    this.openAbonementDialog({
      userId: pickerUserId,
      sectionIds,
      hint: sectionIds.length
        ? 'Клиент может записаться только после сохранения оплаченного абонемента на нужную секцию.'
        : 'Выберите секцию и период. Для разового визита — пресет «Разовое посещение».',
    });
  };

  formatListDate = (raw) => formatProfileDate(raw) || '—';

  formatListDateTime = (raw) => {
    if (raw == null || raw === '') return '—';
    const datePart = formatProfileDate(raw);
    const time = String(raw).match(/T(\d{2}:\d{2})/);
    if (datePart && time) return `${datePart} ${time[1]}`;
    return datePart || String(raw);
  };

  renderClientNameLink = (label, onOpen) => (
    <button
      type="button"
      className={this.props.classes.clientNameLink}
      onClick={onOpen}
    >
      {label || '—'}
    </button>
  );

  renderScrollTable = (table) => (
    <div className={this.props.classes.tableWrap}>{table}</div>
  );

  closeAbonementDialog = () => {
    this.setState({
      abonementDialogOpen: false,
      abonementSaveLoading: false,
      abonementFormError: '',
      abonementDialogHint: '',
    });
  };

  handleAbonementFieldChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (!name) return;
    this.setState((prev) => ({
      abonementForm: {
        ...prev.abonementForm,
        [name]: type === 'checkbox' ? checked : value,
      },
      abonementFormError: '',
    }));
  };

  /** Явная запись дат — не полагаемся на event.target.name (бывали пустые name у date input). */
  setAbonementDateField = (field) => (event) => {
    const value = event && event.target ? event.target.value : '';
    this.setState((prev) => ({
      abonementForm: {
        ...prev.abonementForm,
        [field]: value || '',
      },
      abonementFormError: '',
    }));
  };

  handleAbonementSectionIdsChange = (event) => {
    this.setState((prev) => ({
      abonementForm: { ...prev.abonementForm, sectionIds: event.target.value },
    }));
  };

  /** Нормализация к YYYY-MM-DD для input type=date и API. */
  toAbonementDateInput = (raw) => {
    if (raw == null || raw === '') return '';
    if (typeof raw === 'string') {
      const s = raw.trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
      // dd.mm.yyyy
      const m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s);
      if (m) {
        const dd = m[1].padStart(2, '0');
        const mm = m[2].padStart(2, '0');
        return `${m[3]}-${mm}-${dd}`;
      }
    }
    const d = raw instanceof Date ? raw : new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  todayDateInput = () => this.toAbonementDateInput(new Date());

  addDaysDateInput = (baseYmd, days) => {
    if (!baseYmd) return '';
    const parts = baseYmd.split('-').map(Number);
    if (parts.length !== 3) return '';
    const dt = new Date(parts[0], parts[1] - 1, parts[2]);
    dt.setDate(dt.getDate() + Number(days) || 0);
    return this.toAbonementDateInput(dt);
  };

  requestIsFinal = (status) => {
    const n = Number(status);
    if (n === 2 || n === 3) return true;
    const x = (status || '').toString().toLowerCase();
    return x === 'approved' || x === 'rejected' || x === '2' || x === '3';
  };

  findPendingRequestsForUser = (userId) => {
    if (userId == null) return [];
    return (this.state.requests || []).filter((req) => {
      const uid = getUserIdFromRequest(req);
      if (uid == null || Number(uid) !== Number(userId)) return false;
      return !this.requestIsFinal(req.status);
    });
  };

  findApprovedRequestsForUser = (userId) => {
    if (userId == null) return [];
    return (this.state.requests || []).filter((req) => {
      const uid = getUserIdFromRequest(req);
      if (uid == null || Number(uid) !== Number(userId)) return false;
      const n = Number(req.status);
      if (n === 2) return true;
      return (req.status || '').toString().toLowerCase() === 'approved';
    });
  };

  collectSectionIdsFromRequests = (requests) => {
    const ids = [];
    (requests || []).forEach((req) => {
      const sid = this.getRequestSectionId(req);
      if (sid != null) ids.push(Number(sid));
    });
    return [...new Set(ids.filter((id) => !Number.isNaN(id)))];
  };

  openAbonementDialog = ({
    userId = '',
    sectionIds = [],
    dateFrom = '',
    dateTo = '',
    isPaid = false,
    hint = '',
    editingId = null,
    tariffId = '',
    amount = '',
    note = '',
    visitLimit = '',
    visitsRemaining = '',
  } = {}) => {
    const normalizedSectionIds = (sectionIds || [])
      .map((id) => Number(id))
      .filter((id) => !Number.isNaN(id));
    const sectionIdForClients =
      normalizedSectionIds[0]
      || this.state.abonementFilterSectionId
      || this.state.detailSectionId
      || null;
    this.loadTariffs();
    this.loadClients(sectionIdForClients);
    this.setState({
      clientCardRow: null,
      abonementDialogOpen: true,
      abonementDialogHint: hint || '',
      editingAbonementId: editingId,
      abonementFormError: '',
      abonementForm: {
        userId: userId != null ? String(userId) : '',
        dateFrom: dateFrom || '',
        dateTo: dateTo || '',
        isPaid: !!isPaid,
        sectionIds: normalizedSectionIds,
        tariffId: tariffId != null && tariffId !== '' ? String(tariffId) : '',
        amount: amount != null && amount !== '' ? String(amount) : '',
        note: note || '',
        visitLimit: visitLimit != null && visitLimit !== '' ? String(visitLimit) : '',
        visitsRemaining: visitsRemaining != null && visitsRemaining !== '' ? String(visitsRemaining) : '',
      },
    });
  };

  applyAbonementDurationPreset = (preset) => {
    if (!preset) return;
    const today = this.todayDateInput();
    const dateTo = preset.days === 0 ? today : this.addDaysDateInput(today, preset.days);
    this.setState((prev) => ({
      abonementForm: {
        ...prev.abonementForm,
        dateFrom: today,
        dateTo,
        isPaid: preset.isPaid != null ? !!preset.isPaid : prev.abonementForm.isPaid,
      },
      abonementFormError: '',
    }));
  };

  openAbonementAfterRequestApproved = async (req) => {
    if (!req) return;
    const userId = req.userId != null ? req.userId : req.UserId;
    const sectionId = this.getRequestSectionId(req);
    const clientName = this.requestPersonLabel(req);
    const sectionIds = sectionId != null ? [Number(sectionId)] : [];
    const today = this.todayDateInput();
    const preferredTariffId = req.preferredTariffId != null
      ? req.preferredTariffId
      : (req.PreferredTariffId != null ? req.PreferredTariffId : null);
    const tariffs = (await this.loadTariffs()) || this.state.tariffs || [];
    const preferred = preferredTariffId != null
      ? tariffs.find((tr) => Number(tr.id) === Number(preferredTariffId))
      : null;
    const oneTime = this.isOneTimeRequest(req);
    let dateTo = today;
    if (preferred && preferred.durationDays != null && Number(preferred.durationDays) > 0) {
      dateTo = this.addDaysDateInput(today, Number(preferred.durationDays));
    }
    this.openAbonementDialog({
      userId: userId != null ? String(userId) : '',
      sectionIds,
      dateFrom: today,
      dateTo,
      isPaid: true,
      tariffId: preferred ? preferred.id : '',
      amount: preferred && preferred.price != null ? preferred.price : '',
      note: preferred ? `По заявке: тариф «${preferred.name}»` : '',
      hint:
        `Заявка одобрена: ${clientName}`
        + (oneTime ? ' (разовое). ' : '. ')
        + 'Выдайте абонемент — без оплаченного абонемента на секцию клиент не сможет записаться в приложении. '
        + (oneTime
          ? 'Для разового визита удобен пресет «Разовое посещение».'
          : 'Для первого визита удобен пресет «Разовое посещение».'),
    });
  };

  submitAbonement = async () => {
    const centerId = this.getCenterId();
    const { editingAbonementId, abonementForm } = this.state;
    const clientRef = clientRefFromPickerValue(this.state.complexClientOptions, abonementForm.userId);
    if (!hasPickerClient(clientRef)) {
      this.setState({
        abonementFormError: 'Выберите клиента',
      });
      return;
    }
    const dateFrom = this.toAbonementDateInput(abonementForm.dateFrom);
    const dateTo = this.toAbonementDateInput(abonementForm.dateTo);
    if (!dateFrom || !dateTo) {
      this.setState({
        abonementFormError: 'Укажите даты начала и окончания (поля выше)',
        abonementForm: { ...abonementForm, dateFrom, dateTo },
      });
      return;
    }
    if (dateFrom > dateTo) {
      this.setState({ abonementFormError: 'Дата начала не может быть позже даты окончания' });
      return;
    }
    if (!abonementForm.sectionIds || !abonementForm.sectionIds.length) {
      this.setState({ abonementFormError: 'Выберите хотя бы одну секцию' });
      return;
    }

    const amountRaw = abonementForm.amount;
    const amount = amountRaw === '' || amountRaw == null ? null : Number(amountRaw);
    if (amountRaw !== '' && amountRaw != null && (Number.isNaN(amount) || amount < 0)) {
      this.setState({ abonementFormError: 'Сумма сделки должна быть числом ≥ 0' });
      return;
    }
    const visitLimitRaw = abonementForm.visitLimit;
    const visitsRemainingRaw = abonementForm.visitsRemaining;
    const visitLimit = visitLimitRaw === '' || visitLimitRaw == null ? null : Number(visitLimitRaw);
    const visitsRemaining = visitsRemainingRaw === '' || visitsRemainingRaw == null
      ? null
      : Number(visitsRemainingRaw);
    if (visitLimitRaw !== '' && visitLimitRaw != null && (Number.isNaN(visitLimit) || visitLimit < 0)) {
      this.setState({ abonementFormError: 'Лимит визитов должен быть числом ≥ 0' });
      return;
    }
    if (visitsRemainingRaw !== '' && visitsRemainingRaw != null
      && (Number.isNaN(visitsRemaining) || visitsRemaining < 0)) {
      this.setState({ abonementFormError: 'Остаток визитов должен быть числом ≥ 0' });
      return;
    }
    if (visitLimit != null && visitsRemaining != null && visitsRemaining > visitLimit) {
      this.setState({ abonementFormError: 'Остаток не может быть больше лимита' });
      return;
    }
    const payload = {
      ...sectionClientWriteFields(clientRef),
      dateFrom,
      dateTo,
      isPaid: !!abonementForm.isPaid,
      sectionIds: abonementForm.sectionIds.map((id) => Number(id)),
      sportComplexId: Number(centerId),
      amount,
      currency: 'RUB',
      tariffId: abonementForm.tariffId ? Number(abonementForm.tariffId) : null,
      note: (abonementForm.note || '').trim() || null,
      visitLimit,
      // Create: пустой остаток при заданном лимите = полный пакет.
      // Update: не подставлять лимит вместо пустого остатка (иначе сброс N → Limit).
      visitsRemaining: editingAbonementId
        ? visitsRemaining
        : (visitsRemaining != null ? visitsRemaining : (visitLimit != null ? visitLimit : null)),
    };

    this.setState({ abonementSaveLoading: true, abonementFormError: '' });
    try {
      if (editingAbonementId) {
        await api.updateAbonement(editingAbonementId, { ...payload, id: editingAbonementId });
      } else {
        await api.createAbonement(payload);
      }
      this.closeAbonementDialog();
      await this.loadAbonements();
      await this.loadPaidSum();
      await this.loadClients(abonementForm.sectionIds && abonementForm.sectionIds[0] ? abonementForm.sectionIds[0] : null);
    } catch (error) {
      this.setState({
        abonementSaveLoading: false,
        abonementFormError: error.message || 'Не удалось сохранить абонемент',
      });
    }
  };

  deleteAbonement = async (id) => {
    if (!window.confirm('Удалить абонемент?')) return;
    this.setState({ abonementDeleteId: id, abonementsError: '' });
    try {
      await api.deleteAbonement(id);
      await this.loadAbonements();
      await this.loadPaidSum();
      this.setState({ abonementDeleteId: null });
    } catch (error) {
      this.setState({
        abonementDeleteId: null,
        abonementsError: error.message || 'Не удалось удалить абонемент',
      });
    }
  };

  normalizePersonalStartInput = (row) => {
    const raw = row.startAt || row.startDateTime || row.dateTime || row.scheduledAt || row.start;
    if (!raw) return '';
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  normalizePersonalEndInput = (row) => {
    const raw = row.endAt || row.endDateTime || row.end;
    if (raw) {
      const d = new Date(raw);
      if (!Number.isNaN(d.getTime())) {
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
      }
    }
    const startRaw = row.startAt || row.startDateTime || row.start;
    const duration =
      row.durationMinutes != null
        ? Number(row.durationMinutes)
        : row.duration != null
          ? Number(row.duration)
          : 60;
    if (!startRaw || !duration || Number.isNaN(duration)) return '';
    const start = new Date(startRaw);
    if (Number.isNaN(start.getTime())) return '';
    const end = new Date(start.getTime() + duration * 60 * 1000);
    const pad = (n) => String(n).padStart(2, '0');
    return `${end.getFullYear()}-${pad(end.getMonth() + 1)}-${pad(end.getDate())}T${pad(end.getHours())}:${pad(end.getMinutes())}`;
  };

  loadPersonalTrainings = async () => {
    const centerId = this.getCenterId();
    const { personalFilterSectionId } = this.state;
    this.setState({ personalLoading: true, personalError: '' });
    try {
      const params = { complexId: centerId };
      if (personalFilterSectionId) params.sectionId = personalFilterSectionId;
      const data = await api.getPersonalTrainings(params);
      let list = [];
      if (Array.isArray(data)) list = data;
      else if (data && Array.isArray(data.items)) list = data.items;
      else if (data && Array.isArray(data.results)) list = data.results;
      this.setState({ personalTrainings: list, personalLoading: false });
    } catch (error) {
      this.setState({
        personalLoading: false,
        personalError: error.message || 'Не удалось загрузить персональные тренировки',
      });
    }
  };

  handlePersonalFilterSectionChange = (event) => {
    this.setState({ personalFilterSectionId: event.target.value }, () => this.loadPersonalTrainings());
  };

  handlePersonalFilterUserBlur = () => {
    this.loadPersonalTrainings();
  };

  openCreatePersonalDialog = () => {
    const firstSectionId = this.state.sections[0] && this.state.sections[0].id;
    const sectionId = firstSectionId != null ? firstSectionId : '';
    this.loadClients(sectionId || null);
    this.setState({
      personalDialogOpen: true,
      editingPersonalId: null,
      personalFormError: '',
      personalForm: {
        sectionId,
        userId: '',
        startDateTime: '',
        endDateTime: '',
        durationMinutes: '60',
        trainerId: '',
        playgroundId: '',
      },
    });
  };

  openEditPersonalDialog = (row) => {
    const sid = row.sectionId != null ? row.sectionId : row.section && row.section.id;
    this.loadClients(sid || null);
    this.setState({
      clientCardRow: null,
      personalDialogOpen: true,
      editingPersonalId: row.id,
      personalFormError: '',
      personalForm: {
        sectionId: sid != null ? sid : '',
        userId: row.userId != null ? String(row.userId) : '',
        startDateTime: this.normalizePersonalStartInput(row),
        endDateTime: this.normalizePersonalEndInput(row),
        durationMinutes:
          row.durationMinutes != null ? String(row.durationMinutes) : row.duration != null ? String(row.duration) : '60',
        trainerId: row.trainerId != null ? String(row.trainerId) : '',
        playgroundId: row.playgroundId != null ? String(row.playgroundId) : '',
      },
    });
  };

  closePersonalDialog = () => {
    this.setState({
      personalDialogOpen: false,
      personalSaveLoading: false,
      personalFormError: '',
    });
  };

  handlePersonalFieldChange = (event) => {
    const { name, value } = event.target;
    this.setState((prev) => ({
      personalForm: { ...prev.personalForm, [name]: value },
    }));
  };

  handlePersonalSectionSelectChange = (event) => {
    const sectionId = event.target.value;
    this.setState((prev) => ({
      personalForm: { ...prev.personalForm, sectionId },
    }));
    this.refreshComplexClientOptions(sectionId || null);
  };

  submitPersonalTraining = async () => {
    const centerId = this.getCenterId();
    const { editingPersonalId, personalForm } = this.state;
    const sectionId = Number(personalForm.sectionId);
    const clientRef = clientRefFromPickerValue(this.state.complexClientOptions, personalForm.userId);
    if (!sectionId) {
      this.setState({ personalFormError: 'Выберите секцию' });
      return;
    }
    if (!hasPickerClient(clientRef)) {
      this.setState({
        personalFormError: 'Выберите клиента',
      });
      return;
    }
    if (!personalForm.startDateTime) {
      this.setState({ personalFormError: 'Укажите дату и время начала' });
      return;
    }
    const startAt = new Date(personalForm.startDateTime);
    if (Number.isNaN(startAt.getTime())) {
      this.setState({ personalFormError: 'Некорректная дата и время начала' });
      return;
    }

    let endAt = null;
    let durationMinutes = personalForm.durationMinutes === '' ? null : Number(personalForm.durationMinutes);
    if (personalForm.endDateTime) {
      endAt = new Date(personalForm.endDateTime);
      if (Number.isNaN(endAt.getTime())) {
        this.setState({ personalFormError: 'Некорректная дата и время конца' });
        return;
      }
      if (endAt.getTime() <= startAt.getTime()) {
        this.setState({ personalFormError: 'Конец должен быть позже начала' });
        return;
      }
      durationMinutes = Math.max(1, Math.round((endAt.getTime() - startAt.getTime()) / 60000));
    } else if (!durationMinutes || Number.isNaN(durationMinutes) || durationMinutes <= 0) {
      this.setState({ personalFormError: 'Укажите конец или длительность (мин)' });
      return;
    }

    const payload = {
      sectionId,
      ...sectionClientWriteFields(clientRef),
      startAt: startAt.toISOString(),
      endAt: endAt ? endAt.toISOString() : undefined,
      durationMinutes,
      trainerId: personalForm.trainerId === '' ? null : Number(personalForm.trainerId),
      playgroundId: personalForm.playgroundId === '' ? null : Number(personalForm.playgroundId),
      sportComplexId: Number(centerId),
    };

    this.setState({ personalSaveLoading: true, personalFormError: '' });
    try {
      if (editingPersonalId) {
        await api.updatePersonalTraining(editingPersonalId, { ...payload, id: editingPersonalId });
      } else {
        await api.createPersonalTraining(payload);
      }
      this.closePersonalDialog();
      await this.loadPersonalTrainings();
      await this.loadClients(personalForm.sectionId || null);
    } catch (error) {
      this.setState({
        personalSaveLoading: false,
        personalFormError: error.message || 'Не удалось сохранить тренировку',
      });
    }
  };

  deletePersonalTraining = async (id) => {
    if (!window.confirm('Удалить персональную тренировку?')) return;
    this.setState({ personalDeleteId: id, personalError: '' });
    try {
      await api.deletePersonalTraining(id);
      await this.loadPersonalTrainings();
      this.setState({ personalDeleteId: null });
    } catch (error) {
      this.setState({
        personalDeleteId: null,
        personalError: error.message || 'Не удалось удалить тренировку',
      });
    }
  };

  loadClients = async (sectionIdForPaid = null) => {
    const centerId = this.getCenterId();
    if (!centerId) return;
    this.setState({ clientsLoading: true, complexClientsLoading: true, clientsError: '' });
    let settled;
    let organization = null;
    let orgClients = [];
    try {
      settled = await Promise.allSettled([
        api.getSectionRequests({ complexId: centerId }),
        api.getAbonements({ complexId: centerId }),
        api.getPersonalTrainings({ complexId: centerId }),
        api.getComplexSectionGroupMembers(centerId),
        api.getOrganizationByComplex(centerId),
      ]);
    } catch (error) {
      this.setState({
        clientsLoading: false,
        complexClientsLoading: false,
        clientsError: error.message || 'Не удалось загрузить данные клиентов',
      });
      return;
    }
    const errs = [];
    const pull = (idx) => {
      const r = settled[idx];
      if (r.status === 'fulfilled') return normalizeListResponse(r.value);
      const msg = r.reason && r.reason.message ? r.reason.message : 'ошибка API';
      errs.push(msg);
      return [];
    };
    const requests = pull(0);
    const abonements = pull(1);
    const personalTrainings = pull(2);
    const groupMembers = pull(3);
    if (settled[4] && settled[4].status === 'fulfilled') {
      organization = settled[4].value;
    } else if (settled[4] && settled[4].status === 'rejected') {
      errs.push('организация ещё не привязана к комплексу');
    }
    const orgId = organizationIdFrom(organization);
    if (orgId) {
      try {
        orgClients = normalizeListResponse(await api.getOrganizationClients(orgId));
      } catch (e) {
        errs.push(e.message || 'клиенты организации');
      }
    }
    const orgExtraUsers = (orgClients || [])
      .filter((c) => c.linkedUserId || c.LinkedUserId || c.userId || c.UserId)
      .map((c) => ({
        id: c.linkedUserId || c.LinkedUserId || c.userId || c.UserId,
        name: c.displayName || c.DisplayName || c.name || c.Name,
        phoneNumber: c.phoneRaw || c.PhoneRaw || c.phoneNumber || c.PhoneNumber,
      }));
    const clientsUserMap = buildClientsUserMap({
      requests,
      abonements,
      personalTrainings,
      groupMembers,
      extraUsers: orgExtraUsers,
    });
    const clientsRows = aggregateSectionClients(
      requests,
      abonements,
      personalTrainings,
      groupMembers,
    );
    // Карточки организации: локальные + связанные (для unmerge)
    (orgClients || []).forEach((c) => {
      const linked = c.linkedUserId || c.LinkedUserId;
      const bcId = c.id || c.Id;
      const name = c.displayName || c.DisplayName || '—';
      const phone = c.phoneRaw || c.PhoneRaw || c.phoneNormalized || c.PhoneNormalized || '';
      if (linked) {
        const existing = clientsRows.find((r) => Number(r.userId) === Number(linked));
        if (existing) {
          existing.businessClientId = bcId;
          existing.linked = true;
          const sources = existing.sources || (existing.sources = []);
          if (!sources.includes('связан с аккаунтом')) sources.push('связан с аккаунтом');
        } else {
          clientsRows.push({
            userId: linked,
            businessClientId: bcId,
            name,
            phone,
            email: '',
            sources: ['карточка организации', 'связан с аккаунтом'],
            linked: true,
          });
        }
        return;
      }
      clientsRows.push({
        userId: null,
        businessClientId: bcId,
        name,
        phone,
        email: '',
        sources: ['карточка организации'],
      });
    });
    const paidSectionId =
      sectionIdForPaid
      || this.state.scheduleSectionId
      || this.state.abonementFilterSectionId
      || this.state.personalFilterSectionId
      || null;
    const paidUserIds = collectPaidUserIds(abonements, paidSectionId);
    let pickerSource = orgClients || [];
    if (orgId) {
      try {
        const pickerItems = normalizeListResponse(await api.getOrganizationClientsPicker(orgId));
        if (pickerItems.length) pickerSource = pickerItems;
      } catch (e) {
        if (!pickerSource.length) errs.push(e.message || 'пикер клиентов');
      }
    }
    const orgOptions = mapOrgClientsToPickerOptions(pickerSource, { paidUserIds });
    (pickerSource || []).forEach((c) => {
      const uidRaw = c.userId != null ? c.userId : (c.UserId != null ? c.UserId : (c.linkedUserId || c.LinkedUserId));
      if (uidRaw == null || uidRaw === '') return;
      const uid = Number(uidRaw);
      if (Number.isNaN(uid)) return;
      if (clientsRows.some((r) => r.userId != null && Number(r.userId) === uid)) return;
      clientsRows.push({
        userId: uid,
        businessClientId: c.businessClientId || c.BusinessClientId || null,
        name: c.name || c.Name || c.displayName || c.DisplayName || '',
        phone: c.phoneNumber || c.PhoneNumber || c.phoneRaw || c.PhoneRaw || '',
        email: c.email || c.Email || '',
        sources: ['пользователь приложения'],
        linked: true,
      });
    });
    const sectionOptions = buildComplexClientOptions({
      requests,
      abonements,
      personalTrainings,
      groupMembers,
      userMap: clientsUserMap,
      sectionId: paidSectionId,
    });
    const complexClientOptions = mergePickerOptions(orgOptions, sectionOptions);
    this.setState({
      clientsRows,
      clientsUserMap,
      complexClientOptions,
      organization,
      orgClients,
      clientsLoading: false,
      complexClientsLoading: false,
      clientsError: errs.length ? `Частичная загрузка: ${errs.join('; ')}` : '',
      _clientsCache: { requests, abonements, personalTrainings, groupMembers },
    });
  };

  refreshComplexClientOptions = (sectionId = null) => {
    const { orgClients, _clientsCache, clientsUserMap } = this.state;
    const cache = _clientsCache;
    if (!cache && !(orgClients && orgClients.length)) {
      this.loadClients(sectionId);
      return;
    }
    const paidUserIds = collectPaidUserIds(cache && cache.abonements, sectionId);
    const orgOptions = mapOrgClientsToPickerOptions(orgClients || [], { paidUserIds });
    const sectionOptions = cache
      ? buildComplexClientOptions({
        ...cache,
        userMap: clientsUserMap || {},
        sectionId,
      })
      : [];
    this.setState({
      complexClientOptions: mergePickerOptions(orgOptions, sectionOptions),
    });
  };

  getOrganizationId = () => organizationIdFrom(this.state.organization);

  openSectionCard = (section) => {
    if (!section || section.id == null) return;
    const sid = section.id;
    this.setState(
      {
        detailSectionId: sid,
        detailTab: 'main',
        scheduleSectionId: sid,
        requestFilterSectionId: String(sid),
        abonementFilterSectionId: String(sid),
        personalFilterSectionId: String(sid),
      },
      () => {
        this.loadGroups(sid);
        this.loadRequests();
        this.loadAbonements();
        this.loadPersonalTrainings();
      },
    );
  };

  closeSectionCard = () => {
    this.setState({ detailSectionId: null, detailTab: 'main' });
  };

  openMembersDialog = async (group) => {
    const sectionId = this.state.scheduleSectionId || this.state.detailSectionId;
    if (!sectionId || !group) return;
    this.loadClients(sectionId);
    this.setState({
      membersDialogOpen: true,
      membersGroup: group,
      membersRows: [],
      membersError: '',
      membersAddUserId: '',
      membersAddSearch: '',
      userSearchResults: [],
    });
    this.setState({ membersLoading: true });
    try {
      const rows = await api.getSectionGroupMembers(sectionId, group.id);
      this.setState({
        membersRows: Array.isArray(rows) ? rows : [],
        membersLoading: false,
      });
    } catch (error) {
      this.setState({
        membersLoading: false,
        membersError: error.message || 'Не удалось загрузить состав',
      });
    }
  };

  closeMembersDialog = () => {
    this.setState({
      membersDialogOpen: false,
      membersGroup: null,
      membersRows: [],
      membersError: '',
      membersSaveLoading: false,
    });
  };

  searchUsersForMembers = async (query) => {
    const q = (query || '').trim();
    this.setState({ membersAddSearch: query });
    if (q.length < 2) {
      this.setState({ userSearchResults: [] });
      return;
    }
    this.setState({ userSearchLoading: true });
    try {
      const users = await api.getUsers(q);
      this.setState({
        userSearchResults: normalizeListResponse(users).slice(0, 20),
        userSearchLoading: false,
      });
    } catch (e) {
      this.setState({ userSearchResults: [], userSearchLoading: false });
    }
  };

  addMemberToGroup = async () => {
    const { membersGroup, membersAddUserId, scheduleSectionId, detailSectionId } = this.state;
    const sectionId = scheduleSectionId || detailSectionId;
    const clientRef = clientRefFromPickerValue(this.state.complexClientOptions, membersAddUserId);
    if (!membersGroup || !sectionId || !hasPickerClient(clientRef)) {
      this.setState({
        membersError: 'Выберите клиента',
      });
      return;
    }
    this.setState({ membersSaveLoading: true, membersError: '' });
    try {
      await api.addSectionGroupMember(sectionId, membersGroup.id, {
        ...sectionClientWriteFields(clientRef),
      });
      const rows = await api.getSectionGroupMembers(sectionId, membersGroup.id);
      await this.loadClients(sectionId);
      this.setState({
        membersRows: Array.isArray(rows) ? rows : [],
        membersSaveLoading: false,
        membersAddUserId: '',
        membersAddSearch: '',
        userSearchResults: [],
      });
    } catch (error) {
      this.setState({
        membersSaveLoading: false,
        membersError: error.message || 'Не удалось добавить участника',
      });
    }
  };

  removeMemberFromGroup = async (memberId) => {
    const { membersGroup, scheduleSectionId, detailSectionId } = this.state;
    const sectionId = scheduleSectionId || detailSectionId;
    if (!membersGroup || !sectionId) return;
    if (!window.confirm('Удалить участника из группы?')) return;
    this.setState({ membersDeleteId: memberId, membersError: '' });
    try {
      await api.removeSectionGroupMember(sectionId, membersGroup.id, memberId);
      const rows = await api.getSectionGroupMembers(sectionId, membersGroup.id);
      this.setState({
        membersRows: Array.isArray(rows) ? rows : [],
        membersDeleteId: null,
      });
    } catch (error) {
      this.setState({
        membersDeleteId: null,
        membersError: error.message || 'Не удалось удалить участника',
      });
    }
  };

  markRequestInProgress = async (req) => {
    this.setState({ markInProgressLoadingId: req.id, requestsError: '' });
    try {
      await api.updateSectionRequest(req.id, { status: 'InProgress' });
      await this.loadRequests();
      this.setState({ markInProgressLoadingId: null });
    } catch (error) {
      this.setState({
        markInProgressLoadingId: null,
        requestsError: error.message || 'Не удалось сменить статус',
      });
    }
  };

  openApproveDialog = async (req) => {
    const sectionId = this.getRequestSectionId(req);
    this.setState({
      approveDialogOpen: true,
      approveTarget: req,
      approveGroupId: req.sectionGroupId != null ? String(req.sectionGroupId) : '',
      approveError: '',
      approveGroups: [],
    });
    if (!sectionId) {
      this.setState({ approveError: 'У заявки не указана секция' });
      return;
    }
    this.setState({ approveGroupsLoading: true });
    try {
      const groups = await api.getSectionGroups(sectionId);
      this.setState({
        approveGroups: Array.isArray(groups) ? groups : [],
        approveGroupsLoading: false,
      });
    } catch (error) {
      this.setState({
        approveGroupsLoading: false,
        approveError: error.message || 'Не удалось загрузить группы секции',
      });
    }
  };

  closeApproveDialog = () => {
    this.setState({
      approveDialogOpen: false,
      approveTarget: null,
      approveGroupId: '',
      approveError: '',
      approveSaveLoading: false,
      approveGroups: [],
    });
  };

  submitApprove = async () => {
    const { approveTarget, approveGroupId } = this.state;
    if (!approveTarget) return;
    if (this.isGroupRequest(approveTarget) && !approveGroupId) {
      this.setState({ approveError: 'Выберите группу для групповой заявки' });
      return;
    }
    this.setState({ approveSaveLoading: true, approveError: '' });
    try {
      const body = { status: 'Approved' };
      if (approveGroupId) body.sectionGroupId = Number(approveGroupId);
      await api.updateSectionRequest(approveTarget.id, body);
      this.closeApproveDialog();
      await this.loadRequests();
      this.openAbonementAfterRequestApproved(approveTarget);
    } catch (error) {
      this.setState({
        approveSaveLoading: false,
        approveError: error.message || 'Не удалось одобрить заявку',
      });
    }
  };

  goIssueAbonementFromReminder = () => {
    const {
      abonementReminderUserId,
      abonementReminderClientName,
      abonementReminderSectionId,
    } = this.state;
    this.setState({ abonementReminderOpen: false });
    const sectionIds = abonementReminderSectionId != null ? [Number(abonementReminderSectionId)] : [];
    const today = this.todayDateInput();
    this.openAbonementDialog({
      userId: abonementReminderUserId != null ? String(abonementReminderUserId) : '',
      sectionIds,
      dateFrom: today,
      dateTo: today,
      isPaid: true,
      hint: abonementReminderClientName
        ? `Оформите абонемент для ${abonementReminderClientName}.`
        : 'Оформите абонемент — без него клиент не сможет записаться в приложении.',
    });
  };

  rejectRequest = async (req) => {
    this.setState({ requestActionLoadingId: req.id, requestsError: '' });
    try {
      await api.updateSectionRequest(req.id, { status: 'Rejected' });
      await this.loadRequests();
      this.setState({ requestActionLoadingId: null });
    } catch (error) {
      this.setState({
        requestActionLoadingId: null,
        requestsError: error.message || 'Не удалось отклонить заявку',
      });
    }
  };

  openCreateDialog = () => {
    this.setState({
      dialogOpen: true,
      editingSectionId: null,
      formError: '',
      form: { name: '', sport: '', description: '' },
    });
  };

  openEditDialog = (section) => {
    this.setState({
      dialogOpen: true,
      editingSectionId: section.id,
      formError: '',
      form: {
        name: section.name || '',
        sport: section.sport != null ? String(section.sport) : '',
        description: section.description || '',
      },
    });
  };

  closeDialog = () => {
    this.setState({
      dialogOpen: false,
      saveLoading: false,
      formError: '',
    });
  };

  handleFieldChange = (event) => {
    const { name, value } = event.target;
    this.setState((prev) => ({ form: { ...prev.form, [name]: value } }));
  };

  submitSection = async () => {
    const centerId = this.getCenterId();
    const { editingSectionId, form } = this.state;
    const name = (form.name || '').trim();
    if (!name) {
      this.setState({ formError: 'Название секции обязательно' });
      return;
    }

    const payload = {
      name,
      description: (form.description || '').trim(),
      sport: form.sport === '' ? null : Number(form.sport),
      sportComplexId: Number(centerId),
    };

    this.setState({ saveLoading: true, formError: '' });
    try {
      if (editingSectionId) {
        await api.updateSection(editingSectionId, { ...payload, id: editingSectionId });
      } else {
        await api.createSection(payload);
      }
      this.closeDialog();
      await this.loadSections();
    } catch (error) {
      this.setState({
        saveLoading: false,
        formError: error.message || 'Не удалось сохранить секцию',
      });
    }
  };

  deleteSection = async (sectionId) => {
    this.setState({ deleteLoadingId: sectionId, sectionsError: '' });
    try {
      await api.deleteSection(sectionId);
      await this.loadSections();
      this.setState({ deleteLoadingId: null });
    } catch (error) {
      this.setState({
        deleteLoadingId: null,
        sectionsError: error.message || 'Не удалось удалить секцию',
      });
    }
  };

  renderListView() {
    const { classes } = this.props;
    const {
      sections,
      sectionsLoading,
      sectionsError,
      deleteLoadingId,
      dialogOpen,
      editingSectionId,
      saveLoading,
      formError,
      form,
    } = this.state;

    return (
      <Paper variant="outlined" className={classes.placeholder}>
        <div className={classes.listHeader}>
          <Typography variant="h6">Секции</Typography>
          <Button size="small" variant="contained" color="primary" onClick={this.openCreateDialog}>
            Добавить секцию
          </Button>
        </div>
        <Typography variant="body2" color="textSecondary" className={classes.fieldHint}>
          {SECTIONS_LIST_HINT}
        </Typography>

        {sectionsError && (
          <Typography color="error" className={classes.errorText}>
            {sectionsError}
          </Typography>
        )}

        {sectionsLoading ? (
          <div className={classes.loader}>
            <CircularProgress size={26} />
          </div>
        ) : this.renderScrollTable(
          <Table size="small" className={classes.wideTable}>
            <TableHead>
              <TableRow>
                <TableCell>Название</TableCell>
                <TableCell>Спорт</TableCell>
                <TableCell>Групп</TableCell>
                <TableCell>Новых заявок</TableCell>
                <TableCell>Описание</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sections.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Typography color="textSecondary">Секции пока не добавлены</Typography>
                  </TableCell>
                </TableRow>
              )}
              {sections.map((section) => (
                <TableRow key={section.id}>
                  <TableCell>{section.name}</TableCell>
                  <TableCell>{formatSectionSportLabel(section.sport)}</TableCell>
                  <TableCell>
                    {section.groupCount != null ? section.groupCount : section.GroupCount != null ? section.GroupCount : '—'}
                  </TableCell>
                  <TableCell>
                    {section.newRequestCount != null
                      ? section.newRequestCount
                      : section.NewRequestCount != null
                        ? section.NewRequestCount
                        : '—'}
                  </TableCell>
                  <TableCell>{section.description || '-'}</TableCell>
                  <TableCell align="right">
                    <div className={classes.tableActions}>
                    <Button size="small" color="primary" onClick={() => this.openSectionCard(section)}>
                      Открыть
                    </Button>
                    <Button size="small" color="primary" onClick={() => this.openEditDialog(section)}>
                      Редактировать
                    </Button>
                    <Button
                      size="small"
                      color="secondary"
                      disabled={deleteLoadingId === section.id}
                      onClick={() => this.deleteSection(section.id)}
                    >
                      Удалить
                    </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        <Dialog open={dialogOpen} onClose={this.closeDialog} fullWidth maxWidth="sm">
          <DialogTitle>{editingSectionId ? 'Редактирование секции' : 'Новая секция'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              name="name"
              label="Название"
              value={form.name}
              onChange={this.handleFieldChange}
              fullWidth
              required
            />
            <FormControl fullWidth margin="dense">
              <InputLabel id="section-sport-label">Вид спорта</InputLabel>
              <Select
                labelId="section-sport-label"
              name="sport"
                value={form.sport === '' || form.sport == null ? '' : String(form.sport)}
              onChange={this.handleFieldChange}
                displayEmpty
              >
                <MenuItem value="">
                  <em>Не выбран</em>
                </MenuItem>
                {SECTION_SPORT_OPTIONS.map((opt) => (
                  <MenuItem key={opt.key} value={String(opt.flag)}>
                    {opt.label}
                  </MenuItem>
                ))}
                {form.sport !== ''
                  && form.sport != null
                  && !SECTION_SPORT_OPTIONS.some((opt) => String(opt.flag) === String(form.sport)) && (
                  <MenuItem value={String(form.sport)}>
                    {formatSectionSportLabel(form.sport)} (текущее)
                  </MenuItem>
                )}
              </Select>
            </FormControl>
            <TextField
              margin="dense"
              name="description"
              label="Описание"
              value={form.description}
              onChange={this.handleFieldChange}
              fullWidth
              multiline
              rows={3}
            />
            {formError && (
              <Typography color="error" className={classes.errorText}>
                {formError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.closeDialog} disabled={saveLoading}>
              Отмена
            </Button>
            <Button color="primary" variant="contained" onClick={this.submitSection} disabled={saveLoading}>
              {saveLoading ? 'Сохранение...' : 'Сохранить'}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }

  renderHallScheduleBlock() {
    const { playgrounds } = this.props;
    const { scheduleSectionId, schedulePlaygroundId } = this.state;
    const centerId = this.getCenterIdFromProps(this.props);
    const centerPlaygrounds = (playgrounds || []).filter(
      (p) => Number(p.complexId || p.ComplexId) === Number(centerId),
    );

    return (
      <UnifiedHallSchedule
        playgrounds={centerPlaygrounds}
        selectedPlaygroundId={schedulePlaygroundId}
        onPlaygroundChange={(id) => this.setState({ schedulePlaygroundId: String(id) })}
        sportComplexId={centerId}
        history={this.props.history}
        initialSectionFilterId={scheduleSectionId || ''}
      />
    );
  }

  renderGroupsPanel({ showSectionSelect = false, showTitle = true } = {}) {
    const { classes } = this.props;
    const {
      sections,
      sectionsLoading,
      sectionsError,
      scheduleSectionId,
      groups,
      groupsLoading,
      groupsError,
      groupDeleteId,
    } = this.state;

    return (
      <div className={classes.groupsPanel}>
        <div className={classes.listHeader}>
          {showTitle ? (
            <Typography variant="h6">Группы</Typography>
          ) : (
            <Typography variant="subtitle1">Группы этого направления</Typography>
          )}
          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={!scheduleSectionId || sectionsLoading}
            onClick={this.openCreateGroupDialog}
          >
            Добавить группу
          </Button>
        </div>
        <Typography variant="body2" color="textSecondary" className={classes.fieldHint} paragraph>
          {SECTIONS_GROUPS_HINT}
        </Typography>

        {sectionsError && (
          <Typography color="error" className={classes.errorText}>
            {sectionsError}
          </Typography>
        )}

        {showSectionSelect && (
        <FormControl className={classes.sectionSelect} margin="normal" fullWidth>
          <InputLabel>Секция</InputLabel>
          <Select
            value={scheduleSectionId || ''}
            onChange={this.handleScheduleSectionChange}
            disabled={sectionsLoading || !sections.length}
          >
            {sections.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        )}

        {groupsError && (
          <Typography color="error" className={classes.errorText}>
            {groupsError}
          </Typography>
        )}

        {groupsLoading || sectionsLoading ? (
          <div className={classes.loader}>
            <CircularProgress size={26} />
          </div>
        ) : this.renderScrollTable(
          <Table size="small" className={classes.wideTable}>
            <TableHead>
              <TableRow>
                <TableCell>Группа</TableCell>
                <TableCell>Расписание</TableCell>
                <TableCell>Макс.</TableCell>
                <TableCell>Режим</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!scheduleSectionId && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography color="textSecondary">
                      Нет секций — добавьте в разделе «Секции»
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {!!scheduleSectionId && groups.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography color="textSecondary">
                      Групп пока нет — добавьте первую, чтобы клиенты видели слоты в приложении.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {groups.map((g) => (
                <TableRow key={g.id}>
                  <TableCell>{g.name}</TableCell>
                  <TableCell>{this.formatGroupScheduleHint(g)}</TableCell>
                  <TableCell>{g.maxParticipants != null ? g.maxParticipants : '—'}</TableCell>
                  <TableCell>{g.isClosedGroup ? 'Закрытая' : 'Открытая'}</TableCell>
                  <TableCell align="right">
                    <div className={classes.tableActions}>
                    <Button size="small" color="primary" onClick={() => this.openMembersDialog(g)}>
                      Состав
                    </Button>
                    <Button size="small" color="primary" onClick={() => this.openEditGroupDialog(g)}>
                      Изменить
                    </Button>
                    <Button
                      size="small"
                      color="secondary"
                      disabled={groupDeleteId === g.id}
                      onClick={() => this.deleteGroup(g.id)}
                    >
                      Удалить
                    </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    );
  }

  renderGroupDialog() {
    const { classes } = this.props;
    const {
      groupDialogOpen,
      editingGroupId,
      groupSaveLoading,
      groupFormError,
      groupForm,
    } = this.state;

    return (
        <Dialog open={groupDialogOpen} onClose={this.closeGroupDialog} fullWidth maxWidth="sm">
          <DialogTitle>{editingGroupId ? 'Редактирование группы' : 'Новая группа'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              name="name"
              label="Название группы"
              value={groupForm.name}
              onChange={this.handleGroupFieldChange}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              name="maxParticipants"
              label="Макс. участников (пусто = без лимита)"
              type="number"
              value={groupForm.maxParticipants}
              onChange={this.handleGroupFieldChange}
              fullWidth
              inputProps={{ min: 0 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="isClosedGroup"
                  checked={groupForm.isClosedGroup}
                  onChange={this.handleGroupFieldChange}
                />
              }
              label="Закрытая группа"
            />
          <FormControl fullWidth margin="dense">
            <InputLabel id="group-playground-select-label" shrink>
              Площадка (опционально)
            </InputLabel>
            <Select
              labelId="group-playground-select-label"
              value={groupForm.playgroundId || ''}
              onChange={(e) =>
                this.setState((prev) => ({
                  groupForm: { ...prev.groupForm, playgroundId: e.target.value },
                }))
              }
              displayEmpty
            >
              <MenuItem value="">
                <em>Не задана</em>
              </MenuItem>
              {(this.props.playgrounds || [])
                .filter(
                  (p) =>
                    Number(p.complexId || p.ComplexId) === Number(this.getCenterId()),
                )
                .map((p) => (
                  <MenuItem key={p.id} value={String(p.id)}>
                    {p.name || `Площадка #${p.id}`}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {this.renderTrainerSelect(
            groupForm.trainerId,
            (trainerId) =>
              this.setState((prev) => ({
                groupForm: { ...prev.groupForm, trainerId },
              })),
            'Тренер (опционально)',
            'group-trainer',
          )}

            <Typography variant="subtitle2" className={classes.schedulesTitle}>
              Расписание (повтор по неделе)
            </Typography>
            {groupForm.schedules.map((row, idx) => (
              <div key={idx} className={classes.scheduleRow}>
                <FormControl className={classes.scheduleDay} margin="dense">
                  <InputLabel>День</InputLabel>
                  <Select
                    value={row.dayOfWeek}
                    onChange={(e) => this.handleScheduleRowChange(idx, 'dayOfWeek', e.target.value)}
                  >
                    {WEEKDAYS.map((d) => (
                      <MenuItem key={d.value} value={d.value}>
                        {d.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Начало"
                  type="time"
                  value={row.startTime}
                  onChange={(e) => this.handleScheduleRowChange(idx, 'startTime', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  className={classes.scheduleTime}
                />
                <TextField
                  label="Конец"
                  type="time"
                  value={row.endTime}
                  onChange={(e) => this.handleScheduleRowChange(idx, 'endTime', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  className={classes.scheduleTime}
                />
                <Button size="small" onClick={() => this.removeScheduleRow(idx)}>
                  Удалить
                </Button>
              </div>
            ))}
            <Button size="small" onClick={this.addScheduleRow} className={classes.addSlotBtn}>
              + Слот
            </Button>

            {groupFormError && (
              <Typography color="error" className={classes.errorText}>
                {groupFormError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.closeGroupDialog} disabled={groupSaveLoading}>
              Отмена
            </Button>
            <Button color="primary" variant="contained" onClick={this.submitGroup} disabled={groupSaveLoading}>
              {groupSaveLoading ? 'Сохранение...' : 'Сохранить'}
            </Button>
          </DialogActions>
        </Dialog>
    );
  }

  renderScheduleView() {
    const { classes } = this.props;

    return (
      <Paper variant="outlined" className={classes.placeholder}>
        <div className={classes.listHeader}>
          <Typography variant="h6">Расписание и группы</Typography>
        </div>
        {this.renderHallScheduleBlock()}
        {this.renderGroupsPanel({ showSectionSelect: true, showTitle: true })}
      </Paper>
    );
  }

  renderRequestsView() {
    const { classes } = this.props;
    const {
      sections,
      sectionsLoading,
      requests,
      requestsLoading,
      requestsError,
      requestFilterSectionId,
      requestFilterStatus,
      requestActionLoadingId,
      approveDialogOpen,
      approveGroupId,
      approveError,
      approveSaveLoading,
      approveGroups,
      approveGroupsLoading,
      approveTarget,
      markInProgressLoadingId,
    } = this.state;

    const requestFinal = (status) => this.requestIsFinal(status);

    return (
      <Paper variant="outlined" className={classes.placeholder}>
        <div className={classes.listHeader}>
          <Typography variant="h6">Заявки в секции</Typography>
          <Button size="small" variant="outlined" color="primary" onClick={this.loadRequests} disabled={requestsLoading}>
            Обновить
          </Button>
        </div>
        <Typography variant="body2" color="textSecondary" paragraph>
          Воронка: <strong>Новая</strong> → <strong>В работу</strong> →{' '}
          <strong>Одобрить и оформить абонемент</strong> (заявка принята и сразу открывается форма) или{' '}
          <strong>Отклонить</strong>. Одобрение само по себе не даёт доступ к записи — нужен оплаченный абонемент
          на секцию (для первого визита подойдёт пресет «Разовое посещение»).
        </Typography>

        <div className={classes.filterRow}>
          {!this.isSectionDetailScoped() && (
          <FormControl className={classes.filterControl} margin="dense">
            <InputLabel>Секция</InputLabel>
            <Select
              value={requestFilterSectionId || ''}
              onChange={this.handleRequestFilterSectionChange}
              disabled={sectionsLoading}
            >
              <MenuItem value="">Все секции</MenuItem>
              {sections.map((s) => (
                <MenuItem key={s.id} value={String(s.id)}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          )}
          <FormControl className={classes.filterControl} margin="dense">
            <InputLabel>Статус</InputLabel>
            <Select value={requestFilterStatus || ''} onChange={this.handleRequestFilterStatusChange}>
              {SECTION_REQUEST_STATUSES.map((opt) => (
                <MenuItem key={opt.value || 'all'} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {requestsError && (
          <Typography color="error" className={classes.errorText}>
            {requestsError}
          </Typography>
        )}

        {requestsLoading ? (
          <div className={classes.loader}>
            <CircularProgress size={26} />
          </div>
        ) : this.renderScrollTable(
          <Table size="small" className={classes.wideTable}>
            <TableHead>
              <TableRow>
                <TableCell>Кто</TableCell>
                <TableCell>Как связаться</TableCell>
                <TableCell>Секция</TableCell>
                <TableCell>Тип</TableCell>
                <TableCell>Статус</TableCell>
                <TableCell>Группа</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Typography color="textSecondary">Заявок нет</Typography>
                  </TableCell>
                </TableRow>
              )}
              {requests.filter(Boolean).map((req) => {
                const sid = this.getRequestSectionId(req);
                const sectionName = req.sectionName || req.SectionName || (sid ? this.sectionTitleById(sid) : '—');
                const phone = this.requestPhone(req);
                const email = this.requestEmail(req);
                const comment = this.requestComment(req);
                return (
                  <TableRow key={req.id}>
                    <TableCell>
                      {this.renderClientNameLink(this.requestPersonLabel(req), () => this.openClientCardFromRecord(req))}
                      {comment ? (
                        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                          {comment}
                        </Typography>
                      ) : null}
                    </TableCell>
                    <TableCell>
                      {phone ? (
                        <Typography variant="body2" component="a" href={`tel:${phone}`} style={{ display: 'block' }}>
                          {phone}
                        </Typography>
                      ) : null}
                      {email ? (
                        <Typography variant="body2" component="a" href={`mailto:${email}`} style={{ display: 'block' }}>
                          {email}
                        </Typography>
                      ) : null}
                      {!phone && !email ? '—' : null}
                    </TableCell>
                    <TableCell>{sectionName}</TableCell>
                    <TableCell>{this.requestTypeLabel(req)}</TableCell>
                    <TableCell>{this.requestStatusLabel(req.status)}</TableCell>
                    <TableCell>{this.requestGroupLabel(req)}</TableCell>
                    <TableCell align="right">
                      <div className={classes.tableActions}>
                      <Button
                        size="small"
                        color="default"
                        disabled={
                          requestFinal(req.status) ||
                          markInProgressLoadingId === req.id ||
                          Number(req.status) === 1
                        }
                        onClick={() => this.markRequestInProgress(req)}
                      >
                        В работу
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        disabled={requestFinal(req.status) || requestActionLoadingId === req.id}
                        onClick={() => this.openApproveDialog(req)}
                      >
                        Одобрить и оформить
                      </Button>
                      <Button
                        size="small"
                        color="secondary"
                        disabled={requestFinal(req.status) || requestActionLoadingId === req.id}
                        onClick={() => this.rejectRequest(req)}
                      >
                        Отклонить
                      </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

        <Dialog open={approveDialogOpen} onClose={this.closeApproveDialog} fullWidth maxWidth="sm">
          <DialogTitle>Одобрить заявку и оформить абонемент</DialogTitle>
          <DialogContent>
            {approveTarget && (
              <Typography variant="body2" gutterBottom>
                {this.requestPersonLabel(approveTarget)}
                {this.approveRequestKindLabel(approveTarget)}
              </Typography>
            )}
            {approveTarget && (this.requestPhone(approveTarget) || this.requestEmail(approveTarget)) && (
              <Typography variant="body2" color="textSecondary" gutterBottom>
                {[this.requestPhone(approveTarget), this.requestEmail(approveTarget)].filter(Boolean).join(' · ')}
              </Typography>
            )}
            <Typography variant="body2" color="textSecondary" paragraph>
              После одобрения сразу откроется форма абонемента. Без оплаченного абонемента на секцию клиент
              не сможет записаться в приложении. Для первого визита выберите пресет «Разовое посещение».
            </Typography>
            {this.isGroupRequest(approveTarget) && (
              <FormControl fullWidth margin="normal" disabled={approveGroupsLoading}>
                <InputLabel>Группа</InputLabel>
                <Select
                  value={approveGroupId || ''}
                  onChange={(e) => this.setState({ approveGroupId: e.target.value })}
                >
                  <MenuItem value="">— Выберите группу —</MenuItem>
                  {approveGroups.map((g) => (
                    <MenuItem key={g.id} value={String(g.id)}>
                      {g.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {approveGroupsLoading && (
              <div className={classes.loader}>
                <CircularProgress size={22} />
              </div>
            )}
            {this.isOneTimeRequest(approveTarget) && (
              <Typography variant="body2" color="textSecondary">
                Разовая заявка: группа не нужна. После одобрения откроется выдача (пресет «Разовое посещение»).
                Предпочитаемый тариф из заявки подставится, если он есть в прайсе.
              </Typography>
            )}
            {!this.isGroupRequest(approveTarget) && !this.isOneTimeRequest(approveTarget) && (
              <Typography variant="body2" color="textSecondary">
                Для персональной заявки группа не требуется. При необходимости уточните контракт на backend.
              </Typography>
            )}
            {approveError && (
              <Typography color="error" className={classes.errorText}>
                {approveError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.closeApproveDialog} disabled={approveSaveLoading}>
              Отмена
            </Button>
            <Button color="primary" variant="contained" onClick={this.submitApprove} disabled={approveSaveLoading}>
              {approveSaveLoading ? 'Сохранение...' : 'Одобрить и оформить абонемент'}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }


  renderTariffDialog() {
    const { classes } = this.props;
    const {
      sections,
      tariffDialogOpen,
      tariffFormError,
      editingTariffId,
      tariffSaveLoading,
      tariffForm,
    } = this.state;
    return (
      <Dialog open={tariffDialogOpen} onClose={this.closeTariffDialog} fullWidth maxWidth="sm">
        <DialogTitle>{editingTariffId ? 'Редактирование тарифа' : 'Новый тариф'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Название"
            value={tariffForm.name || ''}
            onChange={(e) => this.setState({ tariffForm: { ...this.state.tariffForm, name: e.target.value } })}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="Цена (₽)"
            type="number"
            value={tariffForm.price || ''}
            onChange={(e) => this.setState({ tariffForm: { ...this.state.tariffForm, price: e.target.value } })}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="Длительность (дней)"
            type="number"
            value={tariffForm.durationDays || ''}
            onChange={(e) => this.setState({ tariffForm: { ...this.state.tariffForm, durationDays: e.target.value } })}
            fullWidth
            helperText="Пусто — срок задаётся вручную при выдаче"
          />
          <TextField
            margin="dense"
            label="Лимит визитов"
            type="number"
            value={tariffForm.visitLimit || ''}
            onChange={(e) => this.setState({ tariffForm: { ...this.state.tariffForm, visitLimit: e.target.value } })}
            fullWidth
            helperText="Пусто — безлимит по визитам (только срок)"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={!!tariffForm.isActive}
                onChange={(e) => this.setState({ tariffForm: { ...this.state.tariffForm, isActive: e.target.checked } })}
              />
            }
            label="Активен (виден клиентам)"
          />
          <FormControl className={classes.sectionSelect} margin="normal" fullWidth>
            <InputLabel>Секции доступа</InputLabel>
            <Select
              multiple
              value={tariffForm.sectionIds || []}
              onChange={(e) => this.setState({ tariffForm: { ...this.state.tariffForm, sectionIds: e.target.value } })}
              renderValue={(selected) =>
                (selected && selected.length)
                  ? sections
                    .filter((s) => selected.indexOf(Number(s.id)) !== -1)
                    .map((s) => s.name)
                    .join(', ')
                  : 'Весь комплекс'
              }
            >
              {sections.map((s) => (
                <MenuItem key={s.id} value={Number(s.id)}>
                  <Checkbox checked={(tariffForm.sectionIds || []).indexOf(Number(s.id)) !== -1} />
                  <ListItemText primary={s.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="caption" color="textSecondary">
            Пустой список секций — тариф на весь комплекс (виден в приложении для любой секции).
          </Typography>
          {tariffFormError && (
            <Typography color="error">{tariffFormError}</Typography>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={this.closeTariffDialog} disabled={tariffSaveLoading}>Отмена</Button>
          <Button color="primary" variant="contained" onClick={this.submitTariff} disabled={tariffSaveLoading}>
            {tariffSaveLoading ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderAbonementDialog() {
    const { classes } = this.props;
    const {
      sections,
      abonementDialogOpen,
      abonementDialogHint,
      abonementFormError,
      editingAbonementId,
      abonementSaveLoading,
      abonementForm,
    } = this.state;

    return (
      <Dialog open={abonementDialogOpen} onClose={this.closeAbonementDialog} fullWidth maxWidth="sm">
        <DialogTitle>{editingAbonementId ? 'Редактирование абонемента' : 'Выдача абонемента'}</DialogTitle>
        <DialogContent>
          {abonementDialogHint ? (
            <Typography variant="body2" color="textSecondary" paragraph className={classes.fieldHint}>
              {abonementDialogHint}
            </Typography>
          ) : null}
          {!editingAbonementId ? (
            <React.Fragment>
              <Typography variant="body2" color="textSecondary" className={classes.fieldHint}>
                Быстрый период:
              </Typography>
              <div className={classes.abonementPresetRow}>
                {ABONEMENT_DURATION_PRESETS.map((preset) => (
                  <Button
                    key={preset.key}
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => this.applyAbonementDurationPreset(preset)}
                  >
                    {preset.label}
                  </Button>
                ))}
              </div>
            </React.Fragment>
          ) : null}
          <ComplexClientPicker
            selectId="abonement-client"
            options={this.state.complexClientOptions || []}
            value={abonementForm.userId}
            disabled={!!this.state.complexClientsLoading}
            loading={!!this.state.complexClientsLoading}
            preferPaidHint={false}
            helperText="Можно выбрать карточку без приложения — аккаунт создастся по телефону при сохранении."
            orgId={this.getOrganizationId()}
            onCreated={() => this.loadClients(
              (abonementForm.sectionIds && abonementForm.sectionIds[0])
                || this.state.abonementFilterSectionId
                || this.state.detailSectionId
                || null,
            )}
            onChange={(userId) =>
              this.setState((prev) => ({
                abonementForm: { ...prev.abonementForm, userId },
                abonementFormError: '',
              }))
            }
          />
          <TextField
            margin="dense"
            id="abonement-date-from"
            name="dateFrom"
            label="Дата начала"
            type="date"
            value={abonementForm.dateFrom || ''}
            onChange={this.setAbonementDateField('dateFrom')}
            fullWidth
            required
            InputLabelProps={{ shrink: true }}
            inputProps={{ name: 'dateFrom' }}
          />
          <TextField
            margin="dense"
            id="abonement-date-to"
            name="dateTo"
            label="Дата окончания"
            type="date"
            value={abonementForm.dateTo || ''}
            onChange={this.setAbonementDateField('dateTo')}
            fullWidth
            required
            InputLabelProps={{ shrink: true }}
            inputProps={{ name: 'dateTo' }}
          />
          <FormControlLabel
            control={
              <Checkbox name="isPaid" checked={abonementForm.isPaid} onChange={this.handleAbonementFieldChange} />
            }
            label="Оплачен (доступ к записи в приложении)"
          />
          <FormControl className={classes.sectionSelect} margin="dense" fullWidth>
            <InputLabel>Тариф из прайса (опционально)</InputLabel>
            <Select
              value={abonementForm.tariffId || ''}
              onChange={(e) => this.applyTariffToAbonementForm(e.target.value)}
            >
              <MenuItem value="">Без тарифа / вручную</MenuItem>
              {(this.state.tariffs || []).filter((x) => x.isActive !== false).map((tr) => (
                <MenuItem key={tr.id} value={String(tr.id)}>
                  {tr.name} — {tr.price} ₽
                  {tr.durationDays ? ` / ${tr.durationDays} дн.` : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            margin="dense"
            id="abonement-amount"
            name="amount"
            label="Сумма сделки (₽)"
            type="number"
            value={abonementForm.amount || ''}
            onChange={this.handleAbonementFieldChange}
            fullWidth
            helperText="Фиксируется при выдаче; смена прайса позже её не меняет"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            margin="dense"
            id="abonement-note"
            name="note"
            label="Заметка (скидка / акция)"
            value={abonementForm.note || ''}
            onChange={this.handleAbonementFieldChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            margin="dense"
            id="abonement-visit-limit"
            name="visitLimit"
            label="Лимит визитов"
            type="number"
            value={abonementForm.visitLimit || ''}
            onChange={this.handleAbonementFieldChange}
            fullWidth
            helperText="Пусто — безлимит. Списание при «Пришёл» / «Не пришёл» в ростере"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            margin="dense"
            id="abonement-visits-remaining"
            name="visitsRemaining"
            label="Осталось визитов"
            type="number"
            value={abonementForm.visitsRemaining || ''}
            onChange={this.handleAbonementFieldChange}
            fullWidth
            helperText="Можно поправить вручную при ошибке отметки"
            InputLabelProps={{ shrink: true }}
          />
          <FormControl className={classes.sectionSelect} margin="normal" fullWidth>
            <InputLabel>Секции / направления (мультивыбор)</InputLabel>
            <Select
              multiple
              value={abonementForm.sectionIds}
              onChange={this.handleAbonementSectionIdsChange}
              renderValue={(selected) =>
                sections
                  .filter((s) => selected.indexOf(Number(s.id)) !== -1)
                  .map((s) => s.name)
                  .join(', ')
              }
            >
              {sections.map((s) => (
                <MenuItem key={s.id} value={Number(s.id)}>
                  <Checkbox checked={abonementForm.sectionIds.indexOf(Number(s.id)) !== -1} />
                  <ListItemText primary={s.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {abonementFormError && (
            <Typography color="error" className={classes.errorText}>
              {abonementFormError}
            </Typography>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={this.closeAbonementDialog} disabled={abonementSaveLoading}>
            Отмена
          </Button>
          <Button color="primary" variant="contained" onClick={this.submitAbonement} disabled={abonementSaveLoading}>
            {abonementSaveLoading ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderAbonementsView() {
    const { classes } = this.props;
    const {
      sections,
      sectionsLoading,
      abonements,
      abonementsLoading,
      abonementsError,
      abonementFilterSectionId,
      abonementFilterUserId,
      abonementDeleteId,
    } = this.state;

    return (
      <Paper variant="outlined" className={classes.placeholder}>
        <div className={classes.listHeader}>
          <Typography variant="h6">Абонементы</Typography>
          <div className={classes.headerActions}>
            <Button size="small" variant="outlined" color="primary" onClick={this.loadAbonements} disabled={abonementsLoading}>
              Обновить
            </Button>
            <Button size="small" variant="contained" color="primary" onClick={this.openCreateAbonementDialog}>
              Выдать абонемент
            </Button>
          </div>
        </div>

        <Typography variant="body2" color="textSecondary" className={classes.fieldHint}>
          {SECTIONS_ABONEMENT_HINT} Оформление вручную: клиент, период, оплата, секции. Для разового визита —
          пресет «Разовое посещение» (один день, без отдельного типа в системе).
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
          {this.state.paidSumLoading
            ? 'Считаем сумму оплаченных…'
            : (this.state.paidSumError
              ? this.state.paidSumError
              : (this.state.paidSum
                ? `Оплаченные абонементы: ${this.state.paidSum.count != null ? this.state.paidSum.count : (this.state.paidSum.Count || 0)} шт., сумма ${(
                    this.state.paidSum.totalAmount != null
                      ? this.state.paidSum.totalAmount
                      : (this.state.paidSum.TotalAmount != null ? this.state.paidSum.TotalAmount : 0)
                  )} ₽`
                : 'Сумма оплаченных: нет данных'))}
        </Typography>

        <Paper variant="outlined" style={{ padding: 12, marginBottom: 16 }}>
          <div className={classes.listHeader}>
            <Typography variant="subtitle1">Прайс / тарифы</Typography>
            <div className={classes.headerActions}>
              <Button size="small" variant="outlined" onClick={this.loadTariffs} disabled={this.state.tariffsLoading}>
                Обновить
              </Button>
              <Button size="small" variant="contained" color="primary" onClick={() => this.openTariffDialog()}>
                Добавить тариф
              </Button>
            </div>
          </div>
          {this.state.tariffsError ? (
            <Typography color="error">{this.state.tariffsError}</Typography>
          ) : null}
          {this.state.tariffsLoading ? (
            <CircularProgress size={22} />
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Название</TableCell>
                  <TableCell>Цена</TableCell>
                  <TableCell>Срок</TableCell>
                  <TableCell>Визиты</TableCell>
                  <TableCell>Активен</TableCell>
                  <TableCell align="right">Действия</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.tariffs || []).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6}>
                      <Typography color="textSecondary">Тарифов пока нет — добавьте первый</Typography>
                    </TableCell>
                  </TableRow>
                ) : (this.state.tariffs || []).map((tr) => (
                  <TableRow key={tr.id}>
                    <TableCell>{tr.name}</TableCell>
                    <TableCell>{tr.price} ₽</TableCell>
                    <TableCell>{tr.durationDays != null ? `${tr.durationDays} дн.` : 'вручную'}</TableCell>
                    <TableCell>{tr.visitLimit != null ? tr.visitLimit : 'безлимит'}</TableCell>
                    <TableCell>{tr.isActive === false ? 'Нет' : 'Да'}</TableCell>
                    <TableCell align="right">
                      <Button size="small" color="primary" onClick={() => this.openTariffDialog(tr)}>Изменить</Button>
                      <Button
                        size="small"
                        color="secondary"
                        disabled={this.state.tariffDeleteId === tr.id}
                        onClick={() => this.deleteTariff(tr.id)}
                      >
                        Удалить
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Paper>


        <div className={classes.filterRow}>
          {!this.isSectionDetailScoped() && (
          <FormControl className={classes.filterControl} margin="dense">
            <InputLabel>Секция (фильтр)</InputLabel>
            <Select
              value={abonementFilterSectionId || ''}
              onChange={this.handleAbonementFilterSectionChange}
              disabled={sectionsLoading}
            >
              <MenuItem value="">Все</MenuItem>
              {sections.map((s) => (
                <MenuItem key={s.id} value={String(s.id)}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          )}
          <TextField
            className={classes.filterControl}
            margin="dense"
            label="Поиск клиента"
            value={abonementFilterUserId}
            onChange={(e) => this.setState({ abonementFilterUserId: e.target.value })}
            helperText="Имя / телефон / email в загруженном списке"
          />
        </div>

        {abonementsError && (
          <Typography color="error" className={classes.errorText}>
            {abonementsError}
          </Typography>
        )}

        {abonementsLoading || sectionsLoading ? (
          <div className={classes.loader}>
            <CircularProgress size={26} />
          </div>
        ) : this.renderScrollTable(
          <Table size="small" className={classes.wideTable}>
            <TableHead>
              <TableRow>
                <TableCell>Клиент</TableCell>
                <TableCell>Период</TableCell>
                <TableCell>Срок</TableCell>
                <TableCell>Визиты</TableCell>
                <TableCell>Сумма</TableCell>
                <TableCell>Оплата</TableCell>
                <TableCell>Секции</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {abonements.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Typography color="textSecondary">Абонементов нет или список пуст по фильтру</Typography>
                  </TableCell>
                </TableRow>
              )}
              {abonements
                .filter((row) => {
                  const q = (this.state.abonementFilterUserId || '').trim().toLowerCase();
                  if (!q) return true;
                  return clientLabelFromRow(row).toLowerCase().includes(q);
                })
                .map((row) => {
                const { dateFrom, dateTo } = this.normalizeAbonementDates(row);
                const expiry = abonementExpiryBadge(row);
                return (
                  <TableRow key={row.id}>
                    <TableCell>
                      {this.renderClientNameLink(clientLabelFromRow(row), () => this.openClientCardFromRecord(row))}
                    </TableCell>
                    <TableCell>
                      {this.formatListDate(dateFrom)} — {this.formatListDate(dateTo)}
                    </TableCell>
                    <TableCell>
                      {expiry.label ? (
                        <Typography
                          variant="body2"
                          style={{ color: ABONEMENT_EXPIRY_COLORS[expiry.tone] || ABONEMENT_EXPIRY_COLORS.muted }}
                        >
                          {expiry.label}
                        </Typography>
                      ) : '—'}
                    </TableCell>
                    <TableCell>{formatVisitBalance(row)}</TableCell>
                    <TableCell>
                      {row.amount != null || row.Amount != null
                        ? `${row.amount != null ? row.amount : row.Amount} ₽`
                        : '—'}
                    </TableCell>
                    <TableCell>{this.normalizeAbonementPaid(row) ? 'Да' : 'Нет'}</TableCell>
                    <TableCell>{this.abonementSectionsDisplay(row)}</TableCell>
                    <TableCell align="right">
                      <div className={classes.tableActions}>
                      <Button size="small" color="primary" onClick={() => this.openEditAbonementDialog(row)}>
                        Редактировать
                      </Button>
                      <Button
                        size="small"
                        color="secondary"
                        disabled={abonementDeleteId === row.id}
                        onClick={() => this.deleteAbonement(row.id)}
                      >
                        Удалить
                      </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

      </Paper>
    );
  }

  renderPersonalView() {
    const { classes } = this.props;
    const {
      sections,
      sectionsLoading,
      personalTrainings,
      personalLoading,
      personalError,
      personalFilterSectionId,
      personalFilterUserId,
      personalDialogOpen,
      personalFormError,
      editingPersonalId,
      personalSaveLoading,
      personalDeleteId,
      personalForm,
    } = this.state;

    return (
      <Paper variant="outlined" className={classes.placeholder}>
        <div className={classes.listHeader}>
          <Typography variant="h6">Персональные тренировки</Typography>
          <div className={classes.headerActions}>
            <Button size="small" variant="outlined" color="primary" onClick={this.loadPersonalTrainings} disabled={personalLoading}>
              Обновить
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={this.openCreatePersonalDialog}
              disabled={!sections.length}
            >
              Добавить
            </Button>
          </div>
        </div>

        <Typography variant="body2" color="textSecondary" className={classes.fieldHint}>
          Персональная тренировка: клиент комплекса, секция, время начала и длительность.
        </Typography>

        <div className={classes.filterRow}>
          {!this.isSectionDetailScoped() && (
          <FormControl className={classes.filterControl} margin="dense">
            <InputLabel>Секция</InputLabel>
            <Select
              value={personalFilterSectionId || ''}
              onChange={this.handlePersonalFilterSectionChange}
              disabled={sectionsLoading}
            >
              <MenuItem value="">Все</MenuItem>
              {sections.map((s) => (
                <MenuItem key={s.id} value={String(s.id)}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          )}
          <TextField
            className={classes.filterControl}
            margin="dense"
            label="Поиск клиента"
            value={personalFilterUserId}
            onChange={(e) => this.setState({ personalFilterUserId: e.target.value })}
            helperText="Имя / телефон / email в загруженном списке"
          />
        </div>

        {personalError && (
          <Typography color="error" className={classes.errorText}>
            {personalError}
          </Typography>
        )}

        {personalLoading || sectionsLoading ? (
          <div className={classes.loader}>
            <CircularProgress size={26} />
          </div>
        ) : this.renderScrollTable(
          <Table size="small" className={classes.wideTable}>
            <TableHead>
              <TableRow>
                <TableCell>Секция</TableCell>
                <TableCell>Клиент</TableCell>
                <TableCell>Начало</TableCell>
                <TableCell>Длит. (мин)</TableCell>
                <TableCell>Тренер</TableCell>
                <TableCell>Площадка</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {personalTrainings.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Typography color="textSecondary">Записей нет</Typography>
                  </TableCell>
                </TableRow>
              )}
              {personalTrainings
                .filter((row) => {
                  const q = (this.state.personalFilterUserId || '').trim().toLowerCase();
                  if (!q) return true;
                  return clientLabelFromRow(row).toLowerCase().includes(q);
                })
                .map((row) => {
                const sid = row.sectionId != null ? row.sectionId : row.section && row.section.id;
                const startRaw = row.startAt || row.startDateTime || row.dateTime;
                return (
                  <TableRow key={row.id}>
                    <TableCell>{sid ? this.sectionTitleById(sid) : '—'}</TableCell>
                    <TableCell>
                      {this.renderClientNameLink(clientLabelFromRow(row), () => this.openClientCardFromRecord(row))}
                    </TableCell>
                    <TableCell>{this.formatListDateTime(startRaw)}</TableCell>
                    <TableCell>
                      {row.durationMinutes != null ? row.durationMinutes : row.duration != null ? row.duration : '—'}
                    </TableCell>
                    <TableCell>{this.trainerLabelById(row.trainerId)}</TableCell>
                    <TableCell>{this.playgroundLabelFromRow(row)}</TableCell>
                    <TableCell align="right">
                      <div className={classes.tableActions}>
                      <Button size="small" color="primary" onClick={() => this.openEditPersonalDialog(row)}>
                        Редактировать
                      </Button>
                      <Button
                        size="small"
                        color="secondary"
                        disabled={personalDeleteId === row.id}
                        onClick={() => this.deletePersonalTraining(row.id)}
                      >
                        Удалить
                      </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

        <Dialog open={personalDialogOpen} onClose={this.closePersonalDialog} fullWidth maxWidth="sm">
          <DialogTitle>{editingPersonalId ? 'Редактирование тренировки' : 'Новая персональная тренировка'}</DialogTitle>
          <DialogContent>
            <FormControl className={classes.sectionSelect} margin="normal" fullWidth>
              <InputLabel>Секция</InputLabel>
              <Select
                value={personalForm.sectionId === '' ? '' : personalForm.sectionId}
                onChange={this.handlePersonalSectionSelectChange}
                disabled={!sections.length}
              >
                {sections.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <ComplexClientPicker
              selectId="personal-client"
              options={this.state.complexClientOptions || []}
              value={personalForm.userId}
              disabled={!!this.state.complexClientsLoading}
              loading={!!this.state.complexClientsLoading}
              preferPaidHint
              helperText="Можно выбрать карточку без приложения — аккаунт создастся по телефону при сохранении."
              orgId={this.getOrganizationId()}
              onCreated={() => this.loadClients(personalForm.sectionId || null)}
              onChange={(userId) =>
                this.setState((prev) => ({
                  personalForm: { ...prev.personalForm, userId },
                  personalFormError: '',
                }))
              }
            />
            <TextField
              margin="dense"
              name="startDateTime"
              label="Начало"
              type="datetime-local"
              value={personalForm.startDateTime}
              onChange={this.handlePersonalFieldChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="dense"
              name="endDateTime"
              label="Конец"
              type="datetime-local"
              value={personalForm.endDateTime || ''}
              onChange={this.handlePersonalFieldChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              helperText="Можно задать любую длительность (не только час). Если пусто — используется поле ниже."
            />
            <TextField
              margin="dense"
              name="durationMinutes"
              label="Длительность (мин), если конец не указан"
              type="number"
              value={personalForm.durationMinutes}
              onChange={this.handlePersonalFieldChange}
              fullWidth
              inputProps={{ min: 1 }}
            />
            {this.renderTrainerSelect(
              personalForm.trainerId,
              (trainerId) =>
                this.setState((prev) => ({
                  personalForm: { ...prev.personalForm, trainerId },
                })),
              'Тренер (опционально)',
              'personal-trainer',
            )}
            <FormControl fullWidth margin="dense">
              <InputLabel id="personal-playground-select-label" shrink>
                Площадка (опционально)
              </InputLabel>
              <Select
                labelId="personal-playground-select-label"
                value={personalForm.playgroundId || ''}
                onChange={(e) =>
                  this.setState((prev) => ({
                    personalForm: { ...prev.personalForm, playgroundId: e.target.value },
                  }))
                }
                displayEmpty
              >
                <MenuItem value="">
                  <em>Не задана</em>
                </MenuItem>
                {(this.props.playgrounds || [])
                  .filter(
                    (p) =>
                      Number(p.complexId || p.ComplexId) === Number(this.getCenterId()),
                  )
                  .map((p) => (
                    <MenuItem key={p.id} value={String(p.id)}>
                      {p.name || `Площадка #${p.id}`}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {personalFormError && (
              <Typography color="error" className={classes.errorText}>
                {personalFormError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.closePersonalDialog} disabled={personalSaveLoading}>
              Отмена
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.submitPersonalTraining}
              disabled={personalSaveLoading}
            >
              {personalSaveLoading ? 'Сохранение...' : 'Сохранить'}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }

  createOrgClient = async () => {
    const org = this.state.organization;
    const orgId = org && (org.id || org.Id);
    if (!orgId) {
      this.setState({ newClientError: 'Нет организации у комплекса — примените миграцию 23' });
      return;
    }
    const displayName = (this.state.newClientName || '').trim();
    const phone = (this.state.newClientPhone || '').trim();
    if (!displayName || !phone) {
      this.setState({ newClientError: 'Укажите имя и телефон' });
      return;
    }
    this.setState({ newClientSaving: true, newClientError: '' });
    try {
      await api.createOrganizationClient(orgId, { displayName, phone });
      this.setState({ newClientName: '', newClientPhone: '', newClientSaving: false });
      this.loadClients();
    } catch (error) {
      this.setState({
        newClientSaving: false,
        newClientError: error.message || 'Не удалось создать карточку',
      });
    }
  };

  unmergeOrgClient = async (row) => {
    const org = this.state.organization;
    const orgId = org && (org.id || org.Id);
    const clientId = row && row.businessClientId;
    if (!orgId || !clientId) return;
    if (!window.confirm('Отвязать карточку от аккаунта пользователя? История секций не удаляется.')) {
      return;
    }
    this.setState({ unmergeClientId: clientId, clientsError: '' });
    try {
      await api.unmergeOrganizationClient(orgId, clientId);
      this.setState({ unmergeClientId: null, clientCardRow: null });
      this.loadClients();
    } catch (error) {
      this.setState({
        unmergeClientId: null,
        clientsError: error.message || 'Не удалось отвязать (нужны права Owner)',
      });
    }
  };

  openClientCard = (row) => {
    if (!row) return;
    this.setState({ clientCardRow: row });
  };

  openClientCardFromRecord = (record) => {
    if (!record) return;
    const userId = getUserIdFromRequest(record);
    if (userId == null) return;
    const uid = Number(userId);
    const existing = (this.state.clientsRows || []).find(
      (r) => r.userId != null && Number(r.userId) === uid,
    );
    if (existing) {
      this.openClientCard(existing);
      return;
    }
    this.openClientCard({
      userId: uid,
      name: clientLabelFromRow(record, this.state.clientsUserMap || {}) || this.requestPersonLabel(record),
      phone: this.requestPhone(record)
        || record.userPhone
        || record.UserPhone
        || record.phone
        || '',
    });
  };

  closeClientCard = () => {
    this.setState({ clientCardRow: null });
  };

  buildProfileForRow = (row) => {
    if (!row) return null;
    const cache = this.state._clientsCache || {};
    return buildClientProfile({
      row,
      userMap: this.state.clientsUserMap || {},
      abonements: (cache.abonements && cache.abonements.length)
        ? cache.abonements
        : (this.state.abonements || []),
      groupMembers: cache.groupMembers || [],
      personalTrainings: (cache.personalTrainings && cache.personalTrainings.length)
        ? cache.personalTrainings
        : (this.state.personalTrainings || []),
      requests: (cache.requests && cache.requests.length)
        ? cache.requests
        : (this.state.requests || []),
      sections: this.state.sections || [],
    });
  };

  renderClientsView() {
    const { classes } = this.props;
    const {
      clientsRows,
      clientsLoading,
      clientsError,
      clientsSearch,
      clientsUserMap,
      organization,
      newClientName,
      newClientPhone,
      newClientSaving,
      newClientError,
      unmergeClientId,
    } = this.state;

    const orgName = organization && (organization.name || organization.Name);
    const q = (clientsSearch || '').trim().toLowerCase();
    const filtered = !q
      ? clientsRows
      : clientsRows.filter((row) => {
          const u = row.userId != null ? clientsUserMap[row.userId] : null;
          const hay = [
            formatUserLabel(u),
            row.name,
            row.phone,
            u && (u.email || u.Email),
            u && (u.phoneNumber || u.PhoneNumber || u.phone),
            ...(row.sources || []),
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
          return hay.includes(q);
        });

    return (
      <Paper variant="outlined" className={classes.placeholder}>
        <div className={classes.listHeader}>
          <Typography variant="h6">
            {orgName ? `Клиенты организации «${orgName}»` : 'Клиенты организации / секций'}
          </Typography>
          <Button size="small" variant="outlined" color="primary" onClick={this.loadClients} disabled={clientsLoading}>
            Обновить
          </Button>
        </div>
        <Typography variant="body2" color="textSecondary" className={classes.fieldHint}>
          Общая база на организацию (все клубы сети). Карточка создаётся без поиска по пользователям
          приложения; связь с аккаунтом — когда человек сам подаст заявку с тем же телефоном
          или стойка оформит сделку. Откройте строку, чтобы увидеть абонемент и состав в выбранном клубе.
          Отвязка (Owner) не удаляет историю в секциях.
        </Typography>
        <div className={classes.filterRow}>
          <TextField
            className={classes.filterControl}
            margin="dense"
            label="Новый клиент — имя"
            value={newClientName}
            onChange={(e) => this.setState({ newClientName: e.target.value })}
          />
          <TextField
            className={classes.filterControl}
            margin="dense"
            label="Телефон"
            value={newClientPhone}
            onChange={(e) => this.setState({ newClientPhone: e.target.value })}
          />
          <Button
            className={classes.filterAction}
            size="small"
            variant="contained"
            color="primary"
            onClick={this.createOrgClient}
            disabled={newClientSaving || clientsLoading}
          >
            {newClientSaving ? '…' : 'Создать карточку'}
          </Button>
        </div>
        {newClientError && (
          <Typography color="error" className={classes.errorText}>
            {newClientError}
          </Typography>
        )}
        <div className={classes.filterRow}>
          <TextField
            className={classes.filterControl}
            margin="dense"
            label="Поиск (телефон / email / имя)"
            value={clientsSearch}
            onChange={(e) => this.setState({ clientsSearch: e.target.value })}
          />
        </div>
        {clientsError && (
          <Typography color="error" className={classes.errorText}>
            {clientsError}
          </Typography>
        )}
        {clientsLoading ? (
          <div className={classes.loader}>
            <CircularProgress size={26} />
          </div>
        ) : this.renderScrollTable(
          <Table size="small" className={classes.wideTable}>
            <TableHead>
              <TableRow>
                <TableCell>Клиент</TableCell>
                <TableCell>Контакты</TableCell>
                <TableCell>Абонемент</TableCell>
                <TableCell>Связи</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography color="textSecondary">Нет данных</Typography>
                  </TableCell>
                </TableRow>
              )}
              {filtered.map((row) => {
                const u = row.userId != null ? clientsUserMap[row.userId] : null;
                const email = u && (u.email || u.Email);
                const phone =
                  (u && (u.phoneNumber || u.PhoneNumber || u.phone))
                  || row.phone
                  || '';
                const label = row.userId != null
                  ? (formatUserLabel(u) || row.name || '—')
                  : (row.name || 'Карточка без аккаунта');
                const key = clientRowKey(row) || `row-${label}`;
                const canUnmerge = row.linked && row.businessClientId != null;
                const profile = this.buildProfileForRow(row);
                return (
                  <TableRow key={key}>
                    <TableCell>
                      {this.renderClientNameLink(label, () => this.openClientCard(row))}
                    </TableCell>
                    <TableCell>
                      {[phone, email].filter(Boolean).join(' · ') || '—'}
                    </TableCell>
                    <TableCell>{profile ? profile.abonementStatus : '—'}</TableCell>
                    <TableCell>{(row.sources || []).join(', ')}</TableCell>
                    <TableCell align="right">
                      <div className={classes.tableActions}>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => this.openClientCard(row)}
                      >
                        Открыть
                      </Button>
                      {canUnmerge ? (
                        <Button
                          size="small"
                          color="secondary"
                          disabled={unmergeClientId === row.businessClientId}
                          onClick={() => this.unmergeOrgClient(row)}
                        >
                          {unmergeClientId === row.businessClientId ? '…' : 'Отвязать'}
                        </Button>
                      ) : null}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </Paper>
    );
  }

  renderClientCardDialog() {
    const { classes } = this.props;
    const { clientCardRow } = this.state;
    const profile = this.buildProfileForRow(clientCardRow);
    const open = !!clientCardRow && !!profile;
    if (!profile && !clientCardRow) return null;

    const line = (items) => (items && items.length ? items.join(', ') : '—');

    return (
      <Dialog open={open} onClose={this.closeClientCard} fullWidth maxWidth="sm">
        <DialogTitle>{profile ? profile.name : 'Клиент'}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" className={classes.fieldHint}>
            Данные секций и абонементов — по выбранному клубу. Справочник карточек общий на организацию.
                    </Typography>
          {profile ? (
            <React.Fragment>
              <Typography variant="body1">
                {[profile.phone, profile.email].filter(Boolean).join(' · ') || 'Контакты не указаны'}
              </Typography>
              <Typography variant="body2" style={{ marginTop: 8 }}>
                Аккаунт: {profile.hasAccount ? (profile.linked ? 'связан с карточкой' : 'есть') : 'нет (только карточка)'}
              </Typography>
              <Typography variant="body2">
                Абонемент: <strong>{profile.abonementStatus}</strong>
              </Typography>
              <Typography variant="subtitle2" className={classes.clientCardSection}>
                Абонементы
              </Typography>
              {profile.abonements.length === 0 ? (
                <Typography variant="body2" color="textSecondary">Нет абонементов в этом клубе</Typography>
              ) : (
                profile.abonements.map((a) => (
                  <div key={a.id || `${a.dateFrom}-${a.dateTo}`} className={classes.clientCardLine}>
                    <Typography variant="body2">
                      {a.dateFrom || '—'} — {a.dateTo || '—'}
                      {' · '}
                      {a.isPaid ? 'оплачен' : 'не оплачен'}
                      {a.isActive ? ' · действует' : ''}
                      {a.sectionNames.length ? ` · ${a.sectionNames.join(', ')}` : ''}
                    </Typography>
                    {a.id != null ? (
                      this.renderClientNameLink('Открыть', () => {
                        const found = this.findAbonementById(a.id);
                        if (found) this.openEditAbonementDialog(found);
                      })
                    ) : null}
                  </div>
                ))
              )}
              <Typography variant="subtitle2" className={classes.clientCardSection}>
                Секции и группы
              </Typography>
              <Typography variant="body2">
                Секции: {line(profile.sections)}
              </Typography>
              {profile.groups.length === 0 ? (
                <Typography variant="body2" color="textSecondary">Не состоит в группах этого клуба</Typography>
              ) : (
                profile.groups.map((g) => (
                  <Typography key={g.id || g.label} variant="body2">
                    {g.label}
                  </Typography>
                ))
              )}
              {profile.personals.length > 0 ? (
                <React.Fragment>
                  <Typography variant="subtitle2" className={classes.clientCardSection}>
                    Персональные (последние)
                  </Typography>
                  {profile.personals.map((p) => (
                    <div key={p.id || p.startLabel} className={classes.clientCardLine}>
                      <Typography variant="body2">
                        {p.startLabel || '—'}
                        {p.sectionName ? ` · ${p.sectionName}` : ''}
                        {p.upcoming ? ' · предстоит' : ''}
                      </Typography>
                      {p.id != null ? (
                        this.renderClientNameLink('Открыть', () => {
                          const found = this.findPersonalById(p.id);
                          if (found) this.openEditPersonalDialog(found);
                        })
                      ) : null}
                    </div>
                  ))}
                </React.Fragment>
              ) : null}
              {profile.requests.length > 0 ? (
                <React.Fragment>
                  <Typography variant="subtitle2" className={classes.clientCardSection}>
                    Заявки
                  </Typography>
                  {profile.requests.map((r) => (
                    <Typography key={r.id || r.sectionName} variant="body2">
                      {r.sectionName || 'Секция'} · {r.status}
                    </Typography>
                  ))}
                </React.Fragment>
              ) : null}
              {clientCardRow && clientCardRow.userId != null
                && this.findPendingRequestsForUser(Number(clientCardRow.userId)).length > 0 ? (
                  <Typography variant="body2" color="error" className={classes.fieldHint}>
                    Есть неодобренная заявка — сначала нажмите «Одобрить и оформить» в списке заявок.
                    Абонемент без одобрения не даст клиенту записаться в приложении.
                  </Typography>
                ) : null}
            </React.Fragment>
          ) : null}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={this.handleIssueAbonementFromClientCard}
            color="primary"
            disabled={
              clientCardRow
              && clientCardRow.userId != null
              && this.findPendingRequestsForUser(Number(clientCardRow.userId)).length > 0
            }
          >
            Выдать абонемент
          </Button>
          <Button onClick={this.closeClientCard}>
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderSectionDetailCard() {
    const { classes } = this.props;
    const { detailSectionId, detailTab, sections, groups } = this.state;
    if (!detailSectionId) return null;
    const section = (sections || []).find((s) => Number(s.id) === Number(detailSectionId));
    if (!section) return null;
    const groupCount = Array.isArray(groups) ? groups.length : section.groupCount;

    return (
      <Paper variant="outlined" className={classes.detailCard}>
        <div className={classes.detailHeader}>
          <div className={classes.detailTitleBlock}>
            <Typography variant="body2" color="textSecondary">
              Спорт: {formatSectionSportLabel(section.sport)} · групп:{' '}
              {groupCount != null ? groupCount : '—'} · новых заявок:{' '}
              {section.newRequestCount != null ? section.newRequestCount : '—'}
            </Typography>
          </div>
          <div className={classes.detailActions}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => this.openEditDialog(section)}
            >
              Редактировать
            </Button>
          </div>
        </div>
        <Tabs
          value={detailTab === 'groups' ? 'schedule' : detailTab}
          onChange={(_, v) => this.setState({ detailTab: v })}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {DETAIL_TABS.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} />
          ))}
        </Tabs>
        <div className={classes.detailBody}>
          {detailTab === 'main' && (
            <div>
              <Typography variant="body1" paragraph>
                {section.description || 'Описание не задано'}
              </Typography>
              {this.renderGroupsPanel({ showSectionSelect: false, showTitle: false })}
            </div>
          )}
          {(detailTab === 'schedule' || detailTab === 'groups') && (
            <div>
              <Typography variant="body2" color="textSecondary" className={classes.fieldHint} paragraph>
                Таймлайн площадки для этой секции. Управление группами — на вкладке «Обзор».
              </Typography>
              {this.renderHallScheduleBlock()}
            </div>
          )}
          {detailTab === 'requests' && this.renderRequestsView()}
          {detailTab === 'abonements' && this.renderAbonementsView()}
          {detailTab === 'personal' && this.renderPersonalView()}
        </div>
      </Paper>
    );
  }

  renderSharedDialogs() {
    const { classes } = this.props;
    const {
      membersDialogOpen,
      membersGroup,
      membersRows,
      membersLoading,
      membersError,
      membersAddUserId,
      membersSaveLoading,
      membersDeleteId,
      abonementReminderOpen,
      abonementReminderUserId,
    } = this.state;

    return (
      <React.Fragment>
        {this.renderGroupDialog()}
        <Dialog open={membersDialogOpen} onClose={this.closeMembersDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            Состав группы{membersGroup ? `: ${membersGroup.name}` : ''}
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Клиенты организации. Карточку без приложения тоже можно добавить — аккаунт создастся по телефону.
            </Typography>
            <ComplexClientPicker
              selectId="group-member-client"
              options={this.state.complexClientOptions || []}
              value={membersAddUserId}
              disabled={!!this.state.complexClientsLoading}
              loading={!!this.state.complexClientsLoading}
              preferPaidHint
              orgId={this.getOrganizationId()}
              onCreated={() => this.loadClients(this.state.scheduleSectionId || this.state.detailSectionId || null)}
              onChange={(userId) => this.setState({ membersAddUserId: userId, membersError: '' })}
            />
            <Button
              size="small"
              variant="contained"
              color="primary"
              className={classes.compactButton}
              onClick={this.addMemberToGroup}
              disabled={membersSaveLoading || !membersAddUserId}
              style={{ marginTop: 8, marginBottom: 12 }}
            >
              {membersSaveLoading ? 'Добавление...' : 'Добавить в группу'}
            </Button>
            {membersError && (
              <Typography color="error" className={classes.errorText}>
                {membersError}
              </Typography>
            )}
            {membersLoading ? (
              <div className={classes.loader}>
                <CircularProgress size={24} />
              </div>
            ) : this.renderScrollTable(
              <Table size="small" className={classes.wideTable}>
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Контакты</TableCell>
                    <TableCell align="right" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {membersRows.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <Typography color="textSecondary">Состав пуст</Typography>
                  </TableCell>
                </TableRow>
              )}
                  {membersRows.map((m) => (
                    <TableRow key={m.id}>
                      <TableCell>
                        {this.renderClientNameLink(
                          m.userName || m.UserName || `User #${m.userId}`,
                          () => this.openClientCardFromRecord(m),
                        )}
                      </TableCell>
                      <TableCell>
                        {[m.userPhone || m.UserPhone, m.userEmail || m.UserEmail]
                          .filter(Boolean)
                          .join(' · ') || '—'}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          size="small"
                          color="secondary"
                          disabled={membersDeleteId === m.id}
                          onClick={() => this.removeMemberFromGroup(m.id)}
                        >
                          Удалить
                        </Button>
                      </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.closeMembersDialog}>Закрыть</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={abonementReminderOpen}
          onClose={() => this.setState({ abonementReminderOpen: false })}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Оформите абонемент</DialogTitle>
          <DialogContent>
            <Typography variant="body2">
              Заявка одобрена
              {abonementReminderUserId != null ? ` (user #${abonementReminderUserId})` : ''}.
              Право бронировать слоты появится только после активного оплаченного абонемента.
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={() => this.setState({ abonementReminderOpen: false })}>
              Позже
            </Button>
            <Button color="primary" variant="contained" onClick={this.goIssueAbonementFromReminder}>
              Оформить абонемент
            </Button>
          </DialogActions>
        </Dialog>
        {this.renderAbonementDialog()}
        {this.renderTariffDialog()}
        {this.renderClientCardDialog()}
      </React.Fragment>
    );
  }

  render() {
    const { classes, centers } = this.props;
    const activeView = this.getActiveView();
    const centerId = this.getCenterId();
    const activeViewMeta = sectionViews.find((view) => view.key === activeView);
    const hasCenters = Array.isArray(centers) && centers.length > 0;
    const centerIdForUI = centerId || (hasCenters ? String(centers[0].id) : '');
    const { detailSectionId, sections } = this.state;
    const selectedCenter = (centers || []).find(
      (c) => String(c.id) === String(centerIdForUI),
    );
    const centerTitle =
      (selectedCenter && (selectedCenter.name || selectedCenter.Name))
      || '—';
    const detailSection = detailSectionId
      ? (sections || []).find((s) => Number(s.id) === Number(detailSectionId))
      : null;
    const pageTitle = detailSection
      ? detailSection.name
      : (activeView === 'clients'
        ? `Клиенты: ${centerTitle}`
        : `Секции: ${centerTitle}`);
    const pageSubtitle = detailSection
      ? `Клуб: ${centerTitle}`
      : (activeView === 'clients'
        ? 'Справочник клиентов организации: все клубы сети. Карточка без приложения — связь с аккаунтом по телефону при заявке или сделке.'
        : 'Управление секциями комплекса: список, расписание групп, заявки, абонементы и персональные тренировки.');

    return (
      <AdminPageShell
        beforeHeader={
          detailSection ? (
            <Button className={classes.backButton} onClick={this.closeSectionCard}>
              ← К списку секций
            </Button>
          ) : null
        }
        title={pageTitle}
        subtitle={pageSubtitle}
      >
      <Paper className={classes.container} elevation={2}>
        {hasCenters && !detailSectionId && (
          <div className={classes.centerSelectRow}>
            <FormControl className={classes.centerSelect}>
              <InputLabel id="sections-center-select-label">Клуб (спорткомплекс)</InputLabel>
              <Select
                labelId="sections-center-select-label"
                value={centerIdForUI}
                onChange={this.handleCenterSelectChange}
              >
                {centers.map((c) => (
                  <MenuItem key={c.id} value={String(c.id)}>
                    {c.name || 'Без названия'}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}

        {detailSectionId ? (
          this.renderSectionDetailCard()
        ) : (
          <div className={classes.mainContent}>
        {activeView === 'list' && this.renderListView()}
        {activeView === 'schedule' && this.renderScheduleView()}
        {activeView === 'requests' && this.renderRequestsView()}
        {activeView === 'abonements' && this.renderAbonementsView()}
        {activeView === 'personal' && this.renderPersonalView()}
        {activeView === 'clients' && this.renderClientsView()}
        {activeView !== 'list' &&
          activeView !== 'schedule' &&
          activeView !== 'requests' &&
          activeView !== 'abonements' &&
          activeView !== 'personal' &&
          activeView !== 'clients' && (
            <Paper variant="outlined" className={classes.placeholder}>
                  <Typography variant="h6">{activeViewMeta && activeViewMeta.label}</Typography>
              <Typography variant="body2" color="textSecondary">
                Раздел подключен как точка входа. Контент будет добавлен на следующих шагах.
              </Typography>
            </Paper>
          )}
          </div>
        )}
        {this.renderSharedDialogs()}
      </Paper>
      </AdminPageShell>
    );
  }
}

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3),
    borderRadius: 12,
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  centerSelectRow: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  centerSelect: {
    minWidth: 280,
  },
  mainContent: {
    flex: 1,
    minWidth: 0,
    maxWidth: '100%',
  },
  placeholder: {
    padding: theme.spacing(2),
    borderRadius: 8,
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'visible',
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    minWidth: 0,
    '& > .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
      flexShrink: 0,
    },
  },
  headerActions: {
    ...ADMIN_HEADER_ACTIONS,
    '& .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
    },
  },
  compactButton: {
    ...ADMIN_COMPACT_BUTTON,
  },
  errorText: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  sectionSelect: {
    minWidth: 240,
    marginBottom: theme.spacing(2),
  },
  fieldHint: {
    marginBottom: theme.spacing(1),
  },
  trainerPicker: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  schedulesTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  detailCard: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  backButton: {
    alignSelf: 'flex-start',
    marginLeft: theme.spacing(-1),
    ...ADMIN_COMPACT_BUTTON,
    color: '#000000',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  detailHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    '& > * + *': {
      marginLeft: 8,
    },
  },
  detailTitleBlock: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  detailActions: {
    ...ADMIN_HEADER_ACTIONS,
    '& .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
    },
  },
  detailBody: {
    marginTop: theme.spacing(2),
  },
  groupsPanel: {
    marginTop: theme.spacing(1),
  },
  scheduleRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(1),
    '& > * + *': {
      marginLeft: 8,
    },
  },
  scheduleDay: {
    minWidth: 100,
  },
  scheduleTime: {
    width: 120,
    marginRight: theme.spacing(1),
  },
  addSlotBtn: {
    marginTop: theme.spacing(1),
    ...ADMIN_COMPACT_BUTTON,
  },
  filterRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
  filterControl: {
    flex: '1 1 200px',
    minWidth: 180,
    maxWidth: '100%',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  },
  filterAction: {
    flex: '0 0 auto',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    ...ADMIN_COMPACT_BUTTON,
  },
  tableWrap: {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  wideTable: {
    minWidth: 720,
  },
  tableActions: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: 4,
    },
    '& .MuiButton-root': {
      minHeight: 28,
      padding: '2px 8px',
      fontSize: '0.75rem',
      fontWeight: 600,
      textTransform: 'none',
      borderRadius: 6,
      boxShadow: 'none',
      lineHeight: 1.25,
      whiteSpace: 'nowrap',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
  clientNameLink: {
    border: 0,
    padding: 0,
    margin: 0,
    background: 'none',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    font: 'inherit',
    textAlign: 'left',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  clientCardLine: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  clientCardSection: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
  },
  abonementPresetRow: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1.5),
    '& > * + *': {
      marginLeft: 6,
    },
    '& .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
    },
  },
  dialogActions: {
    padding: '8px 16px',
    '& .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
    },
    '& .MuiButton-root + .MuiButton-root': {
      marginLeft: 6,
    },
  },
});

export default connect(
  state => ({
    centers: state.centers || [],
    playgrounds: state.playgrounds || [],
  }),
  { fetchCenters }
)(withStyles(styles)(SectionsDashboard));
